<!-- 收款台操作 -->
<template>
   <div class="store-modal-content">
      <div class="data_action_form">
         <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
            <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="
                  (val) => {
                     showTabs = val
                  }
               ">
               <template slot="tabs" slot-scope="scope">
                  <div class="table_content_box">
                     <!-- 主信息 -->
                     <div v-if="scope.index == 0" class="main-layout">
                        <!-- 左侧区域：表单 + 单品特价设置 -->
                        <div class="left-section">
                           <!-- 表单区域 -->
                           <div class="form-section promotion-form">
                              <el-form size="mini" :model="sendDataInfo" label-width="120px" ref="sendDataInfo" :show-message="false" :inline-message="false">

                                 <!-- 基本信息 -->
                                 <div class="form-group">
                                    <div class="group-title">基本信息 <el-button type="primary" size="mini" @click="openSchemeDialog" :disabled="dataActionBox.actionType == 2">
                                          <i class="el-icon-folder-opened"></i> 选择已有方案
                                       </el-button> </div>
                                    <div class="form-row">
                                       <el-form-item label="方案名称" prop="planName" class="form-item-half" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-input v-model.trim="sendDataInfo.planName" :maxlength="$store.state.inputLength" placeholder="填写方案名称" style="width: 100%;"></el-input>
                                       </el-form-item>
                                       <el-form-item label="会员要求" prop="memReq" class="form-item-half" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-select v-model.number="sendDataInfo.memReq" placeholder="选择会员要求" @change="handleMemberTypeChange" style="width: 100%;">
                                             <el-option label="不限" :value=1></el-option>
                                             <el-option label="会员卡类型" :value=2></el-option>
                                             <!-- <el-option label="会员积分" :value=3></el-option> -->
                                          </el-select>
                                       </el-form-item>

                                       <!-- <el-form-item v-if="sendDataInfo.memReq === 3" label="积分要求" prop="memReqPoint"
                                          class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-input v-model.number="sendDataInfo.memReqPoint" type="number" :min="0"
                                             placeholder="请输入积分要求" style="width: 100%;"></el-input>
                                       </el-form-item>
                              -->

                                    </div>
                                    <div v-if="sendDataInfo.memReq === 2" class="form-row">
                                       <el-form-item label="选择会员卡类型" prop="selectedCardTypeIds" :rules="[{ required: true, trigger: ['blur', 'change'] }]" class="form-item-full">
                                          <div class="card-type-selection">
                                             <div class="selection-header">
                                                <span class="selection-title">已选择 {{ selectedCardTypes.length }}/{{
                                                   cardTypeList.length }} 个会员卡类型</span>
                                             </div>
                                             <el-table :data="cardTypeList" size="mini" height="180" @selection-change="handleCardTypeSelectionChange" ref="cardTypeTable" border>
                                                <el-table-column type="selection" width="55" align="center" :selectable="() => true">
                                                </el-table-column>
                                                <el-table-column prop="capCode" label="卡类型编号" width="120" align="center">
                                                </el-table-column>
                                                <el-table-column prop="capName" label="卡类型名称" min-width="150" align="center">
                                                </el-table-column>
                                                <!-- <el-table-column 
                                                   label="扣率" 
                                                   width="100" 
                                                   align="center">
                                                   <template slot-scope="scope">
                                                      <span v-if="scope.row.isDiscont" class="card-mzDiscount">
                                                         {{ (scope.row.discount * 10).toFixed(0) }}折
                                                      </span>
                                                      <span v-else class="card-no-mzDiscount">无折扣</span>
                                                   </template>
</el-table-column> -->
                                             </el-table>
                                          </div>
                                       </el-form-item>
                                    </div>
                                    <div class="form-row">
                                       <el-form-item label="方案描述" prop="planDesc" class="form-item-full" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-input type="textarea" v-model.trim="sendDataInfo.planDesc" :maxlength="$store.state.inputLength" :rows="3" placeholder="请输入方案描述"></el-input>
                                       </el-form-item>
                                       <el-form-item label="备注" class="form-item-full">
                                          <el-input type="textarea" v-model="sendDataInfo.remark" :rows="3" placeholder="请输入备注信息（选填）"></el-input>
                                       </el-form-item>
                                    </div>
                                 </div>

                                 <!-- 时间设置 -->
                                 <div class="form-group">
                                    <div class="group-title">时间设置</div>
                                    <div class="form-row">
                                       <el-form-item label="开始日期" prop="startDate" class="form-item-half" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-date-picker v-model="sendDataInfo.startDate" type="date" placeholder="选择开始日期" value-format="timestamp" style="width: 100%;">
                                          </el-date-picker>
                                       </el-form-item>
                                       <el-form-item label="结束日期" prop="endDate" class="form-item-half" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-date-picker v-model="sendDataInfo.endDate" type="date" placeholder="选择结束日期" value-format="timestamp" style="width: 100%;">
                                          </el-date-picker>
                                       </el-form-item>
                                    </div>
                                    <div class="form-row">
                                       <el-form-item label="开始时间" prop="dayStartTime" class="form-item-half" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-time-picker v-model="sendDataInfo.dayStartTime" placeholder="选择开始时间" value-format="HH:mm:ss" style="width: 100%;">
                                          </el-time-picker>
                                       </el-form-item>
                                       <el-form-item label="结束时间" prop="dayEndTime" class="form-item-half" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-time-picker v-model="sendDataInfo.dayEndTime" placeholder="选择结束时间" value-format="HH:mm:ss" style="width: 100%;">
                                          </el-time-picker>
                                       </el-form-item>
                                    </div>
                                    <div class="form-row">
                                       <el-form-item label="促销周期" prop="mzWeekDays" class="form-item-half" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <div @click="openPromotionDialog" style="cursor: pointer;">
                                             <el-input type="textarea" v-model="weekDaysDisplayText" readonly class="promotion-input" style="pointer-events: none;" placeholder="点击选择促销周期" :rows="3"></el-input>
                                          </div>
                                       </el-form-item>
                                       <el-form-item label="促销日期" prop="mzMonthDays" class="form-item-half" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <div @click="openPromotionDialog" style="cursor: pointer;">
                                             <el-input type="textarea" v-model="monthDaysDisplayText" readonly class="promotion-input" style="pointer-events: none;" placeholder="点击选择促销日期" :rows="3"></el-input>
                                          </div>
                                       </el-form-item>
                                    </div>
                                 </div>

                              </el-form>
                           </div>

                           <!-- 促销条件块 -->
                           <div class="promotion-condition-section">

                              <div class="condition-title">促销条件</div>

                              <el-form :model="sendDataInfo" size="mini" inline label-width="150px" :show-message="false" :inline-message="false">
                                 <el-form-item label="促销类型" prop="mzConType" :rules="[{ required: true, message: '请选择促销类型', trigger: 'change' }]">
                                    <el-select v-model.number="sendDataInfo.mzConType" placeholder="请选择促销类型" disabled class="form_codition" @change="handlePromotionTypeChange">
                                       <el-option label="按金额" :value=1></el-option>
                                       <el-option label="按商品" :value=2></el-option>
                                       <el-option label="按商品分类" :value=3></el-option>
                                       <!-- <el-option label="按生产厂商" value="按生产厂商"></el-option> -->
                                    </el-select>
                                 </el-form-item>
                                 <!-- <el-form-item label="商品分类" v-if="sendDataInfo.mzConType === 2"
                                    prop="goodsCategory"
                                    :rules="[{ required: sendDataInfo.mzConType === 2, message: '请选择商品分类', trigger: 'blur' }]">
                                    <el-input v-model="sendDataInfo.goodsCategory" class="form_codition"
                                       placeholder="请选择商品分类" 
                                       :disabled="sendDataInfo.mzConType !== 2"></el-input>
                                 </el-form-item>
                                 <el-form-item label="生产厂商" v-if="sendDataInfo.mzConType === 2"
                                    prop="goodsCategory"
                                    :rules="[{ required: sendDataInfo.mzConType === 2, message: '请选择生产厂商', trigger: 'blur' }]">
                                    <el-input v-model="sendDataInfo.goodsCategory" class="form_codition"
                                       placeholder="请选择生产厂商" 
                                       :disabled="sendDataInfo.mzConType !== 2"></el-input>
                                 </el-form-item> -->
                                 <el-form-item label="整单金额要求" prop="mzOrderMoney" :rules="[{ required: sendDataInfo.mzConType == 1, message: '请输入整单金额要求', trigger: 'blur' }]">
                                    <el-input v-model.number="sendDataInfo.mzOrderMoney" class="form_codition" placeholder="请输入整单金额要求" type="number" :min="0" :disabled="sendDataInfo.mzConType !== 1"></el-input>
                                 </el-form-item>
                                 <el-form-item v-if="actionData.limit == 13" label="品种数量要求" prop="mzBgmTypeNum" :rules="[{ required: true, message: '请输入品种数量要求', trigger: 'blur' }]">
                                    {{ sendDataInfo.mzBgmTypeNum = 1 }}
                                 </el-form-item>
                                 <el-form-item v-else label="品种数量要求" prop="mzBgmTypeNum" :rules="[{ required: sendDataInfo.mzConType != 1, message: '请输入品种数量要求', trigger: 'blur' }]">
                                    <el-input v-model.number="sendDataInfo.mzBgmTypeNum" class="form_codition" placeholder="请输入品种数量要求" type="number" :min="0" :disabled="sendDataInfo.mzConType == 1"></el-input>
                                 </el-form-item>
                                 <el-form-item label="条件商品数量要求" prop="mzConBgmNum">
                                    <el-input v-model.number="sendDataInfo.mzConBgmNum" class="form_codition" placeholder="请输入条件商品数量要求" type="number" :min="0" :disabled="sendDataInfo.mzConType == 1"></el-input>
                                 </el-form-item>
                                 <el-form-item label="条件商品金额要求" prop="mzConBgmMoney" :rules="[{ required: false, message: '请输入条件商品金额要求', trigger: 'blur' }]">
                                    <el-input v-model.number="sendDataInfo.mzConBgmMoney" class="form_codition" placeholder="请输入条件商品金额要求" type="number" :min="0" :disabled="sendDataInfo.mzConType == 1"></el-input>
                                 </el-form-item>

                                 <el-form-item label="是否叠加其他方案" prop="mzIsPileOther" v-if="sendDataInfo.mzConType == 1">
                                    <el-radio-group v-model="sendDataInfo.mzIsPileOther" size="mini">
                                       <el-radio-button :label="0">否</el-radio-button>
                                       <el-radio-button :label="1">是</el-radio-button>
                                    </el-radio-group>
                                 </el-form-item>
                                 <el-form-item label="选择叠加方案" prop="mzPileType" v-if="sendDataInfo.mzIsPileOther == 1" :rules="[{ required: sendDataInfo.mzIsPileOther == 1, message: '请选择叠加方案', trigger: 'blur' }]">
                                    <el-checkbox-group v-model="sendDataInfo.mzPileType">
                                       <el-checkbox-button v-for="item in mzPileType" :label="item.value" :key="item.value">{{ item.label
                                          }}</el-checkbox-button>
                                    </el-checkbox-group>
                                 </el-form-item>
                              </el-form>
                              <!-- 商品分类 -->
                              <div class="promotion-container" v-if="sendDataInfo.mzConType == 3">
                                 <!-- 促销条件设置 -->
                                 <div class="promotion-section condition-section">
                                    <div class="section-header-simple">
                                       <div class="header-left-simple">
                                          <h3> 参与商品分类列表</h3>
                                          <p class="section-desc-simple">
                                             {{ '选择能够参与促销活动的商品分类' }}
                                             <span class="list-count">已添加 {{ sendDataInfo.conBgmTypeList.length }}
                                                个商品分类</span>
                                          </p>
                                       </div>
                                       <div class="header-actions-simple" v-if="dataActionBox.actionType != 2">
                                          <el-button type="primary" size="mini" @click="addFDetails">
                                             <i class="el-icon-plus"></i> 添加参与商品分类
                                          </el-button>
                                          <el-button type="danger" size="mini" @click="deleteFDetails()">
                                             <i class="el-icon-delete"></i> 删除商品分类
                                          </el-button>
                                       </div>
                                    </div>
                                    <div class="section-content">
                                       <!-- 商品分类列表 -->
                                       <div class="goods-list-container">
                                          <div class="goods-table-wrapper">
                                             <el-table size="mini" ref="mxFTableRef" id="mxFTable" :data="sendDataInfo.conBgmTypeList" height="200" @row-dblclick="openFDetailsBox" @row-click="handleFRowClick" border>
                                                <el-table-column label="选择" width="80" align="center">
                                                   <template slot-scope="scope">
                                                      <el-radio v-model="selectedDataIndexF" :label="scope.$index" border size="mini">
                                                         <i class="el-icon-thumb"></i>
                                                      </el-radio>
                                                   </template>
                                                </el-table-column>
                                                <el-table-column align="center" width="200" label="分类名称">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.conBgmTypeList[scope.$index].btName }}</span>
                                                   </template>
                                                </el-table-column>
                                                <el-table-column align="center" width="120" label="描述">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.conBgmTypeList[scope.$index].btDesc }}</span>
                                                   </template>
                                                </el-table-column>
                                                <!-- <el-table-column align="center" width="120" label="数量要求">
                                                   <template slot-scope="scope">
                                                      <el-input v-if="dataActionBox.actionType != 2"
                                                         v-model="sendDataInfo.conBgmTypeList[scope.$index].num"
                                                         type="number" size="mini" placeholder="请输入数量" :min="0"
                                                         clearable>
                                                      </el-input>
                                                      <span v-else class="ellipsis-cell">{{
                                                         sendDataInfo.conBgmTypeList[scope.$index].num
                                                      }}</span>
                                                   </template>
                                                </el-table-column>
                                                <el-table-column align="center" width="120" label="金额要求">
                                                   <template slot-scope="scope">
                                                      <el-input v-if="dataActionBox.actionType != 2"
                                                         v-model="sendDataInfo.conBgmTypeList[scope.$index].money"
                                                         type="number" size="mini" placeholder="请输入金额" :min="0"
                                                         clearable>
                                                      </el-input>
                                                      <span v-else class="ellipsis-cell">{{
                                                         sendDataInfo.conBgmTypeList[scope.$index].money
                                                      }}</span>
                                                   </template>
                                                </el-table-column> -->
                                                <!-- 价格设置 -->
                                                <!-- <el-table-column align="center" width="180" label="价格设置">
                                                   <template slot-scope="scope">
                                                      <el-select v-if="dataActionBox.actionType != 2"
                                                         v-model.number="sendDataInfo.conBgmTypeList[scope.$index].priceSet"
                                                         size="mini" placeholder="请选择价格设置">
                                                         <el-option label="价格不变" :value=1></el-option>
                                                         <el-option label="全部恢复原价" :value=2></el-option>

                                                      </el-select>
                                                      <span v-else class="ellipsis-cell">{{
                                                         getPriceSettingText(sendDataInfo.conBgmTypeList[scope.$index].priceSet)
                                                      }}</span>
                                                   </template>
                                                </el-table-column> -->
                                                <el-table-column align="center" width="150" label="备注">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.conBgmTypeList[scope.$index].remark }}</span>
                                                   </template>
                                                </el-table-column>
                                             </el-table>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <!-- 商品列表设置区域 -->
                              <div class="promotion-container">
                                 <!-- 促销条件设置 -->
                                 <div class="promotion-section condition-section">
                                    <div class="section-header-simple">
                                       <div class="header-left-simple">
                                          <h3>{{ isExcludeGoodsMode ? '不参与商品列表' : '参与商品列表' }}</h3>
                                          <p class="section-desc-simple">
                                             {{ isExcludeGoodsMode ? '选择不参与促销活动的商品' : '选择能够参与促销活动的商品' }}
                                             <span class="list-count">已添加 {{ sendDataInfo.specialList.length }}
                                                个商品</span>
                                          </p>
                                       </div>
                                       <div class="header-actions-simple" v-if="dataActionBox.actionType != 2">
                                          <el-button type="primary" size="mini" @click="addDetails">
                                             <i class="el-icon-plus"></i> {{ isExcludeGoodsMode ?
                                                '添加不参与商品' : '添加参与商品' }}
                                          </el-button>

                                          <el-button type="danger" size="mini" @click="deleteDetails()">
                                             <i class="el-icon-delete"></i> 删除商品
                                          </el-button>
                                       </div>
                                    </div>

                                    <div class="section-content">
                                       <!-- 商品列表 -->
                                       <div class="goods-list-container">
                                          <div class="goods-table-wrapper">
                                             <el-table size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.specialList" height="400" @row-dblclick="openDateilsBox" @row-click="handleRowClick" border>
                                                <el-table-column label="选择" width="80" align="center">
                                                   <template slot-scope="scope">
                                                      <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                                                         <i class="el-icon-thumb"></i>
                                                      </el-radio>
                                                   </template>
                                                </el-table-column>
                                                <!-- 商品名称 -->
                                                <el-table-column align="center" width="200" label="通用名称">
                                                   <template slot-scope="scope">
                                                      <!-- <el-input :ref="'bgmName'" v-if="dataActionBox.actionType != 2"
                                                         v-model="sendDataInfo.specialList[scope.$index].bgmName"
                                                         @keyup.enter.native="openSearch('8820873997127710', scope.$index, 'bgmName', 'bgmId,bgmName')"
                                                         clearable
                                                         :placeholder="isExcludeGoodsMode ? '请选择不参与商品' : '请选择商品'">
                                                         <el-button
                                                            @click="openSearch('8820873997127710', scope.$index, 'bgmName', 'bgmId,bgmName')"
                                                            slot="append" icon="el-icon-search"></el-button>
                                                      </el-input> -->
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].bgmName }}</span>
                                                   </template>
                                                </el-table-column>

                                                <!-- 商品编码（促销类型为21时显示） -->
                                                <el-table-column align="center" width="120" label="商品编码">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].bgmCode }}</span>
                                                   </template>
                                                </el-table-column>

                                                <!-- 规格 -->
                                                <el-table-column align="center" width="150" label="规格">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].spec }}</span>
                                                   </template>
                                                </el-table-column>                                                                      
                                                 <el-table-column align="center" width="120" label="最大进价">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].maxPsprice }}</span>
                                                   </template>
                                                </el-table-column>
                                                <!-- 统一零售价 -->
                                                <el-table-column align="center" width="120" label="统一零售价">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].retailPrice }}</span>
                                                   </template>
                                                </el-table-column>

                                                <!-- 单品数量要求 -->
                                                <!-- <el-table-column align="center" width="120" label="单品数量要求"
                                                   v-if="sendDataInfo.mzConType == 2">
                                                   <template slot-scope="scope">
                                                      <el-input v-if="dataActionBox.actionType != 2"
                                                         v-model="sendDataInfo.specialList[scope.$index].itemQtyRequired"
                                                         type="number" size="mini" placeholder="请输入数量" :min="0"
                                                         clearable>
                                                      </el-input>
                                                      <span v-else class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].itemQtyRequired
                                                      }}</span>
                                                   </template>
                                                </el-table-column> -->

                                                <!-- 单品金额要求 -->
                                                <!-- <el-table-column align="center" width="120" label="单品金额要求"
                                                   v-if="sendDataInfo.mzConType == 2">
                                                   <template slot-scope="scope">
                                                      <el-input v-if="dataActionBox.actionType != 2"
                                                         v-model="sendDataInfo.specialList[scope.$index].itemAmountRequired"
                                                         type="number" size="mini" placeholder="请输入金额" :min="0"
                                                         clearable>
                                                      </el-input>
                                                      <span v-else class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].itemAmountRequired
                                                      }}</span>
                                                   </template>
                                                </el-table-column> -->

                                                <!-- 价格设置 -->
                                                <!-- <el-table-column align="center" width="180" label="价格设置"
                                                   v-if="sendDataInfo.mzConType == 2">
                                                   <template slot-scope="scope">
                                                      <el-select v-if="dataActionBox.actionType != 2"
                                                         v-model.number="sendDataInfo.specialList[scope.$index].priceSet"
                                                         size="mini" placeholder="请选择价格设置">
                                                         <el-option label="价格不变" :value=1></el-option>
                                                         <el-option label="全部恢复原价" :value=2></el-option>
                                                         <el-option label="数量要求部分恢复原价" :value=3></el-option>
                                                      </el-select>
                                                      <span v-else class="ellipsis-cell">{{
                                                         getPriceSettingText(sendDataInfo.specialList[scope.$index].priceSet)
                                                      }}</span>
                                                   </template>
                                                </el-table-column> -->
                                                <el-table-column align="center" width="200" label="生产厂家">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].manufacturer }}</span>
                                                   </template>
                                                </el-table-column>
                                                <!-- 产地（促销类型为21时显示） -->
                                                <el-table-column align="center" width="120" label="产地">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].placeorigin }}</span>
                                                   </template>
                                                </el-table-column>
                                             </el-table>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>

                           </div>

                           <!-- 促销内容块 -->
                           <div class="promotion-content-section">
                              <div class="condition-title">促销内容设置</div>

                              <div class="section-content">
                                 <el-form :model="sendDataInfo" inline size="mini" label-width="150px" :show-message="false" :inline-message="false">
                                    <!-- 促销方式 -->
                                    <el-form-item label="促销方式">
                                       <el-select v-model.number="sendDataInfo.mzGiftType" placeholder="请选择促销方式" @change="handlePromotionMethodChange">
                                          <el-option label="赠品" :value=1></el-option>
                                          <el-option label="优惠券" :value=2></el-option>
                                          <el-option label="积分" :value=3></el-option>
                                          <el-option label="原品打折" :value=4 v-if="sendDataInfo.mzConType == 1 || sendDataInfo.mzConType == 3"></el-option>
                                          <el-option label="原品金额减免" :value=5 v-if="sendDataInfo.mzConType == 1 || sendDataInfo.mzConType == 3"></el-option>
                                          <!-- <el-option v-if="sendDataInfo.mzConType == 3" label="优惠最低价格品种金额"
                                             :value=6></el-option> -->
                                       </el-select>
                                    </el-form-item>

                                    <!-- 返现金额 -->
                                    <el-form-item label="返现金额">
                                       <el-input v-model.number="sendDataInfo.mzCashBack" type="number" size="mini" :min="0" controls-position="right" placeholder="请输入返现金额" :disabled="sendDataInfo.mzGiftType !== 5">
                                       </el-input>
                                    </el-form-item>
                                    <!-- 折扣 -->
                                    <el-form-item label="折扣">
                                       <el-input v-model.number="sendDataInfo.mzDiscount" type="number" size="mini" :min="0" controls-position="right" placeholder="请输入折扣" :disabled="sendDataInfo.mzGiftType !== 4">
                                       </el-input>
                                    </el-form-item>
                                    <!-- 赠送积分 -->
                                    <el-form-item label="赠送积分">
                                       <el-input v-model.number="sendDataInfo.mzAddPoint" type="number" size="mini" :min="0" controls-position="right" placeholder="请输入赠送积分" :disabled="sendDataInfo.mzGiftType !== 3">
                                       </el-input>
                                    </el-form-item>
                                    <!-- 冲减积分 -->
                                    <el-form-item label="冲减积分">
                                       <el-input v-model.number="sendDataInfo.mzReducePoint" type="number" size="mini" :min="0" controls-position="right" placeholder="请输入冲减积分"
                                                 :disabled="![1, 2].includes(sendDataInfo.mzGiftType)"></el-input>

                                    </el-form-item>
                                    <!-- 赠品要求 -->
                                    <el-form-item label="赠品要求" v-if="[1, 2].includes(sendDataInfo.mzGiftType)">
                                       <el-select v-model="sendDataInfo.mzGiftNumType" placeholder="请选择赠品要求">
                                          <el-option label="赠送任选一个" :value=1></el-option>
                                          <el-option label="全部赠送" :value=2></el-option>
                                       </el-select>
                                    </el-form-item>
                                    <!-- 是否允许重复赠送 -->
                                    <el-form-item label="是否允许重复赠送" v-if="![4, 5].includes(sendDataInfo.mzGiftType)">
                                       <el-radio-group v-model="sendDataInfo.mzIsRepeat" size="mini">
                                          <el-radio-button label="0">否</el-radio-button>
                                          <el-radio-button label="1">是</el-radio-button>
                                       </el-radio-group>
                                    </el-form-item>
                                 </el-form>
                              </div>

                              <!-- 赠品商品表格 -->
                              <div class="gift-goods-section" v-if="sendDataInfo.mzGiftType === 1">
                                 <div class="section-header-simple">
                                    <div class="header-left-simple">
                                       <h3>赠品商品列表</h3>
                                       <p class="section-desc-simple">
                                          选择作为赠品的商品
                                          <span class="list-count">已添加 {{ sendDataInfo.giftList ?
                                             sendDataInfo.giftList.length : 0 }} 个赠品</span>
                                       </p>
                                    </div>
                                    <div class="header-actions-simple" v-if="dataActionBox.actionType != 2">
                                       <el-button type="primary" size="mini" @click="addGiftDetails">
                                          <i class="el-icon-plus"></i> 添加赠品
                                       </el-button>
                                       <el-button type="danger" size="mini" @click="deleteGiftDetails()">
                                          <i class="el-icon-delete"></i> 删除赠品
                                       </el-button>
                                    </div>
                                 </div>

                                 <div class="section-content">
                                    <div class="goods-list-container">
                                       <div class="goods-table-wrapper">
                                          <el-table size="mini" ref="giftTableRef" id="giftTable" :data="sendDataInfo.giftList || []" height="300" @row-click="handleRowGiftClick" @row-dblclick="openGiftDetailsBox"
                                                    @selection-change="handleGiftSelectionChange" border>
                                             <el-table-column type="selection" width="55" align="center">
                                             </el-table-column>
                                             <!-- 商品名称 -->
                                             <el-table-column align="center" width="200" label="通用名称">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].bgmName }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 商品编码 -->
                                             <el-table-column align="center" width="120" label="商品编码">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].bgmCode }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 规格 -->
                                             <el-table-column align="center" width="150" label="规格">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].spec }}</span>
                                                </template>
                                             </el-table-column>
                                             <!-- 批号 -->
                                             <!-- <el-table-column align="center" width="160" label="批号">
                                                <template slot-scope="scope">
                                                   <el-input clearable
                                                      v-model="sendDataInfo.giftList[scope.$index].batchno"
                                                      @keyup.enter.native="batchnoClick(scope.row)">
                                                      <el-button @click="batchnoClick(scope.row)" slot="append"
                                                         icon="el-icon-search"></el-button></el-input>

                                                </template>
                                             </el-table-column> -->
                                             <el-table-column align="center" width="120" label="最大进价">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].maxPsprice }}</span>
                                                </template>
                                             </el-table-column>
                                             <!-- 统一零售价 -->
                                             <el-table-column align="center" width="120" label="统一零售价">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].retailPrice }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 赠送数量 -->
                                             <el-table-column align="center" width="120" label="赠送数量">
                                                <template slot-scope="scope">
                                                   <el-input v-if="dataActionBox.actionType != 2" v-model="sendDataInfo.giftList[scope.$index].giftNum" type="number" size="mini" placeholder="请输入数量" :min="1" clearable>
                                                   </el-input>
                                                   <span v-else class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].giftNum }}</span>
                                                </template>
                                             </el-table-column>
                                             <!-- 加价 -->
                                             <el-table-column align="center" width="120" label="加价">
                                                <template slot-scope="scope">
                                                   <el-input v-if="dataActionBox.actionType != 2" v-model="sendDataInfo.giftList[scope.$index].price" type="number" size="mini" placeholder="请输入加价" :min="0.01" :step="0.01"
                                                             clearable>
                                                   </el-input>
                                                   <span v-else class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].price }}</span>
                                                </template>
                                             </el-table-column>
                                             <!-- 生产厂家 -->
                                             <el-table-column align="center" width="200" label="生产厂家">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].manufacturer }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 产地 -->
                                             <el-table-column align="center" width="120" label="产地">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].placeorigin }}</span>
                                                </template>
                                             </el-table-column>
                                          </el-table>
                                       </div>
                                    </div>
                                 </div>
                              </div>

                              <!-- 优惠券列表 -->
                              <div class="gift-goods-section" v-if="sendDataInfo.mzGiftType === 2">
                                 <div class="section-header-simple">
                                    <div class="header-left-simple">
                                       <h3>优惠券列表</h3>
                                       <p class="section-desc-simple">
                                          选择作为赠品的优惠券
                                          <span class="list-count">已添加 {{ sendDataInfo.couponList ?
                                             sendDataInfo.couponList.length : 0 }} 个优惠券</span>
                                       </p>
                                    </div>
                                    <div class="header-actions-simple" v-if="dataActionBox.actionType != 2">
                                       <el-button type="primary" size="mini" @click="addCouponDetails">
                                          <i class="el-icon-plus"></i> 添加优惠券
                                       </el-button>
                                       <el-button type="danger" size="mini" @click="deleteCouponDetails()">
                                          <i class="el-icon-delete"></i> 删除优惠券
                                       </el-button>
                                    </div>
                                 </div>

                                 <div class="section-content">
                                    <div class="goods-list-container">
                                       <div class="goods-table-wrapper">
                                          <el-table size="mini" ref="couponTableRef" id="couponTable" :data="sendDataInfo.couponList || []" height="300" @row-dblclick="openCouponDetailsBox" border>
                                             <el-table-column label="选择" width="80" align="center">
                                                <template slot-scope="scope">
                                                   <el-radio v-model="selectedCouponIndex" :label="scope.$index" border size="mini">
                                                      <i class="el-icon-thumb"></i>
                                                   </el-radio>
                                                </template>
                                             </el-table-column>
                                             <!-- 优惠券名称 -->
                                             <el-table-column align="center" width="180" label="优惠券名称">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.couponList[scope.$index].yhqName }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 描述 -->
                                             <el-table-column align="center" width="200" label="描述">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.couponList[scope.$index].yhqDesc }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 使用期限 -->
                                             <el-table-column align="center" width="200" label="使用期限(自发放后有效期)">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.couponList[scope.$index].limitDay }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 赠送数量 -->
                                             <el-table-column align="center" width="120" label="赠送数量">
                                                <template slot-scope="scope">
                                                   <el-input v-if="dataActionBox.actionType != 2" v-model="sendDataInfo.couponList[scope.$index].giftNum" type="number" size="mini" placeholder="请输入数量" :min="1" clearable>
                                                   </el-input>
                                                   <span v-else class="ellipsis-cell">{{
                                                      sendDataInfo.couponList[scope.$index].giftNum }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 备注 -->
                                             <el-table-column align="center" width="200" label="备注">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.couponList[scope.$index].remark }}</span>
                                                </template>
                                             </el-table-column>
                                          </el-table>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <!-- 右侧固定区域 -->
                        <div class="right-section">
                           <div class="section-title">
                              <span class="title-text" v-if="sendDataInfo.mzConType == 2">买赠促销</span>
                              <span class="title-text" v-else-if="sendDataInfo.mzConType == 1">整单促销</span>
                              <span class="title-text" v-else-if="sendDataInfo.mzConType == 3">品牌促销</span>

                           </div>
                           <div class="right-content">
                              <!-- 绑定门店 -->
                              <div class="store-section">
                                 <div class="section-header">
                                    <div class="header-content">
                                       <i class="el-icon-office-building"></i>
                                       <span>绑定门店</span>
                                    </div>
                                    <div class="selection-count">
                                       {{ selectedStores.length }}/{{ storeList.length }}
                                    </div>
                                 </div>
                                 <div class="table-container">
                                    <el-table :data="storeList" size="mini" height="320" @selection-change="handleStoreSelectionChange" @row-click="handleStoreClick" ref="storeTable" class="elegant-table">
                                       <el-table-column type="selection" width="45"></el-table-column>
                                       <el-table-column prop="storeName" label="门店名称" width="120">
                                          <template slot-scope="scope">
                                             <span class="store-name-text">{{ scope.row.storeName || scope.row.name
                                             }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="storeType" label="门店类型" width="100">
                                          <template slot-scope="scope">
                                             <span class="store-type-text">{{ scope.row.storeType || scope.row.type ||
                                                '未知' }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="phone" label="联系电话" width="120">
                                          <template slot-scope="scope">
                                             <span class="store-phone-text">{{ scope.row.storePhone || '暂无' }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="storeAddress" label="门店地址" width="150">
                                          <template slot-scope="scope">
                                             <span class="store-address-text">{{ scope.row.storeAddress ||
                                                scope.row.address || scope.row.location || '暂无' }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="storeArea" label="门店区域" width="100">
                                          <template slot-scope="scope">
                                             <span class="store-area-text">{{ scope.row.storeArea || scope.row.area ||
                                                scope.row.region || '暂无' }}</span>
                                          </template>
                                       </el-table-column>
                                    </el-table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </template>
            </v-tabs>
         </el-card>
      </div>
      <div class="foot">
         <div>
            <el-button @click="drawerCancel">取 消</el-button>
            <el-button type="primary" @click="sendDataAction()" v-if="!checkDisabled">保 存</el-button>
         </div>
      </div>
      <!-- 检索阶梯 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 通用名称列表 -->
      <el-dialog :title="getDialogTitle()" v-if="shopListVisible" :visible.sync="shopListVisible" :modal-append-to-body="true" :append-to-body="true" width="75%" center>
         <div class="store-modal-content">
            <!-- 搜索条件 -->
            <div class="search-container" style="margin-bottom: 20px;">
               <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                  <el-form-item label="商品名称">
                     <el-input v-model="searchForm.bgmName" placeholder="请输入商品名称" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="商品分类">
                     <el-select v-model="searchForm.btId" placeholder="请选择商品分类" clearable>
                        <el-option v-for="item in bgmTypeList" :key="item.btId" :label="item.btName" :value="item.btId"></el-option>
                     </el-select>
                  </el-form-item>
                  <el-form-item label="生产商">
                     <el-input v-model="searchForm.manufacturer" placeholder="请输入生产商" clearable></el-input>
                  </el-form-item>
                  <el-form-item>
                     <el-button type="primary" @click="searchCommonNames">查询</el-button>

                  </el-form-item>
               </el-form>
            </div>

            <!-- 表格 -->
            <el-table :data="commonNamesList" border style="width: 100%" height="400" fit @selection-change="handleCommonNameSelectionChange" @row-click="handleRowGiftModalClick" ref="commonNamesTable">
               <!-- 多选模式：复选框 -->
               <el-table-column v-if="goodsSelectionMode === 'multiple'" type="selection" width="55" fixed>
               </el-table-column>
               <!-- 单选模式：单选框 -->
               <el-table-column v-if="goodsSelectionMode === 'single'" label="选择" width="80" align="center">
                  <template slot-scope="scope">
                     <el-radio v-model="selectedGoodsIndexSingle" :label="scope.$index" border size="mini">
                        <i class="el-icon-thumb"></i>
                     </el-radio>
                  </template>
               </el-table-column>
               <el-table-column prop="bgmCode" label="商品编码" min-width="120">
               </el-table-column>
               <el-table-column prop="bgmName" label="通用名称" min-width="180" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="spec" label="规格" min-width="150" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="manufacturer" label="生产商" min-width="180" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="placeorigin" label="产地" min-width="120" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="maxPsprice" label="最大进价" min-width="120">
               </el-table-column>
               <el-table-column prop="retailPrice" label="统一零售价" min-width="120">
               </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container" style="margin-top: 20px; text-align: right;">
               <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[30, 50, 100, 200]" :page-size="pageSize"
                              layout="total, sizes, prev, pager, next, jumper" :total="total">
               </el-pagination>
            </div>
         </div>
         <div slot="footer" class="dialog-footer">
            <el-button @click="shopListVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitCommonNameSelection">确 定</el-button>
            <el-button v-if="goodsSelectionMode === 'multiple'" type="success" @click="selectAllCommonNames">选择全部</el-button>
         </div>
      </el-dialog>
      <!-- 商品分类列表 -->
      <el-dialog title="添加商品分类" v-if="shopListVisibleF" :visible.sync="shopListVisibleF" :modal-append-to-body="true" :append-to-body="true" width="55%" center>
         <div class="store-modal-content">
            <!-- 搜索条件 -->
            <div class="search-container" style="margin-bottom: 20px;">
               <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                  <el-form-item label="分类名称">
                     <el-input v-model="searchForm.btName" placeholder="请输入分类名称" clearable></el-input>
                  </el-form-item>
                  <el-form-item>
                     <el-button type="primary" @click="searchCommonNamesF">查询</el-button>

                  </el-form-item>
               </el-form>
            </div>
            <!-- 表格 -->
            <el-table :data="commonNamesListF" border style="width: 100%" height="400" fit @selection-change="handleCommonNameSelectionChangeF" @row-click="handleRowGiftModalClickF" ref="commonNamesTableF">
               <!-- 多选模式：复选框 -->
               <el-table-column v-if="categorySelectionMode === 'multiple'" type="selection" width="55" fixed>
               </el-table-column>
               <!-- 单选模式：单选框 -->
               <el-table-column v-if="categorySelectionMode === 'single'" label="选择" width="80" align="center">
                  <template slot-scope="scope">
                     <el-radio v-model="selectedCategoryIndexF" :label="scope.$index" border size="mini">
                        <i class="el-icon-thumb"></i>
                     </el-radio>
                  </template>
               </el-table-column>
               <el-table-column prop="btName" label="分类名称" min-width="180" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="btDesc" label="描述" min-width="150" show-overflow-tooltip>
               </el-table-column>

               <el-table-column prop="remark" label="备注" min-width="120">
               </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination-container" style="margin-top: 20px; text-align: right;">
               <el-pagination @size-change="handleSizeChangeF" @current-change="handleCurrentChangeF" :current-page="currentPageF" :page-sizes="[30, 50, 100, 200]" :page-size="pageSizeF"
                              layout="total, sizes, prev, pager, next, jumper" :total="totalF">
               </el-pagination>
            </div>
         </div>
         <div slot="footer" class="dialog-footer">
            <el-button @click="shopListVisibleF = false">取 消</el-button>
            <el-button type="primary" @click="submitCommonNameSelectionF">确 定</el-button>
            <el-button v-if="categorySelectionMode === 'multiple'" type="success" @click="selectAllCommonNamesF">选择全部</el-button>
         </div>
      </el-dialog>
      <!-- 优惠券列表 -->
      <el-dialog title="选择优惠券" v-if="couponListVisible" :visible.sync="couponListVisible" :modal-append-to-body="true" :append-to-body="true" width="50%" center>
         <div class="store-modal-content">
            <!-- 搜索条件 -->
            <div class="search-container" style="margin-bottom: 20px;">
               <el-form :inline="true" :model="couponSearchForm" class="demo-form-inline">
                  <el-form-item label="优惠券名称">
                     <el-input v-model="couponSearchForm.yhqName" placeholder="请输入优惠券名称" clearable></el-input>
                  </el-form-item>

                  <el-form-item>
                     <el-button type="primary" @click="searchCoupons">查询</el-button>
                     <el-button type="success" @click="selectAllCoupons">选择全部</el-button>
                  </el-form-item>
               </el-form>
            </div>

            <!-- 表格 -->
            <el-table :data="couponsList" border style="width: 100%" height="400" @selection-change="handleCouponSelectionChange" @row-click="handleRowCouponClick" ref="couponsTable">
               <el-table-column type="selection" width="55">
               </el-table-column>
               <el-table-column prop="yhqName" label="优惠券名称" width="180">
               </el-table-column>
               <el-table-column prop="yhqDesc" label="描述" width="200">
               </el-table-column>
               <el-table-column prop="limitDay" label="使用期限(自发放后有效期)" width="200">
               </el-table-column>
               <el-table-column prop="remark" label="备注" width="150">
               </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container" style="margin-top: 20px; text-align: right;">
               <el-pagination @size-change="handleCouponSizeChange" @current-change="handleCouponCurrentChange" :current-page="couponCurrentPage" :page-sizes="[10, 20, 50, 100]" :page-size="couponPageSize"
                              layout="total, sizes, prev, pager, next, jumper" :total="couponTotal">
               </el-pagination>
            </div>
         </div>
         <div slot="footer" class="dialog-footer">
            <el-button @click="couponListVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitCouponSelection">确 定</el-button>
         </div>
      </el-dialog>
      <!-- 批号列表 -->
      <el-dialog title="批号列表" :visible.sync="batchnoListVisible" width="40%" :modal-append-to-body="true" :append-to-body="true" center @open="onBatchnoDialogOpen" @close="onBatchnoDialogClose">
         <div v-if="batchnoList.length > 0">
            <el-table ref="batchnoTable" :data="batchnoList" border style="width: 100%" height="400" @row-click="handleBatchnoClick" highlight-current-row>
               <el-table-column header-align='center' label="选择操作" width="80">
                  <template slot-scope="scope">
                     <el-radio v-model="selectedBatchnoIndex" :label="scope.$index" size="mini">
                        <i class="el-icon-thumb"></i>
                     </el-radio>
                  </template>
               </el-table-column>
               <el-table-column prop="batchno" label="批号" min-width="120"></el-table-column>
               <el-table-column prop="expidate" label="失效日期" min-width="120">
                  <template slot-scope="scope">
                     <span class="ellipsis-cell">{{ $common.getLocalTime(scope.row.expidate) }}</span>
                  </template>
               </el-table-column>
               <el-table-column prop="prodate" label="生产日期" min-width="120">
                  <template slot-scope="scope">
                     <span class="ellipsis-cell">{{ $common.getLocalTime(scope.row.prodate) }}</span>
                  </template>
               </el-table-column>
            </el-table>
         </div>
         <div v-else class="no-data-tip">
            <i class="el-icon-warning-outline"></i>
            <p>没有找到批号数据</p>
         </div>
         <div slot="footer" class="dialog-footer">
            <el-button @click="batchnoListVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitBatchnoSelection" :disabled="batchnoList.length === 0">确
               定</el-button>
         </div>
      </el-dialog>

      <!-- 促销周期和日期选择弹窗 -->
      <el-dialog v-if="promotionDialogVisible" title="促销周期和日期设置" :visible.sync="promotionDialogVisible" width="60%" center :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="false"
                 custom-class="promotion-dialog" :modal="true" :lock-scroll="false">
         <div class="promotion-selection-container">
            <!-- 促销周期选择 -->
            <div class="selection-section">
               <div class="section-header">
                  <h4>促销周期</h4>
                  <div class="selection-actions">
                     <el-button size="mini" @click="selectAllWeekDays">全选</el-button>
                     <el-button size="mini" @click="clearAllWeekDays">不全选</el-button>
                  </div>
               </div>
               <div class="checkbox-group">
                  <el-checkbox-group v-model="tempWeekDays">
                     <el-checkbox-button v-for="item in mzWeekDays" :label="item.value" :key="item.value">
                        {{ item.label }}
                     </el-checkbox-button>
                  </el-checkbox-group>
               </div>
            </div>

            <!-- 促销日期选择 -->
            <div class="selection-section">
               <div class="section-header">
                  <h4>促销日期</h4>
                  <div class="selection-actions">
                     <el-button size="mini" @click="selectAllMonthDays">全选</el-button>
                     <el-button size="mini" @click="clearAllMonthDays">不全选</el-button>
                  </div>
               </div>
               <div class="checkbox-group">
                  <el-checkbox-group v-model="tempMonthDays">
                     <el-checkbox-button v-for="item in mzMonthDays" :label="item.value" :key="item.value">
                        {{ item.label }}
                     </el-checkbox-button>
                  </el-checkbox-group>
               </div>
            </div>
         </div>

         <div slot="footer" class="dialog-footer">
            <el-button @click="cancelPromotionSelection">取 消</el-button>
            <el-button type="primary" @click="confirmPromotionSelection">确 定</el-button>
         </div>
      </el-dialog>
      <!-- 方案选择弹窗 -->
      <el-dialog v-if="schemeDialogVisible" title="选择已有方案" :visible.sync="schemeDialogVisible" width="80%" center :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="false"
                 custom-class="promotion-dialog" :modal="true" :lock-scroll="false">
         <div class="scheme-dialog-content">
            <!-- 搜索区域 -->
            <div class="search-section">
               <el-form :model="schemeSearchForm" inline size="mini">
                  <el-form-item label="方案名称">
                     <el-input v-model="schemeSearchForm.planName" placeholder="请输入方案名称" clearable @keyup.enter.native="searchSchemes"></el-input>
                  </el-form-item>
                  <el-form-item>
                     <el-button type="primary" @click="searchSchemes">
                        <i class="el-icon-search"></i> 搜索
                     </el-button>
                     <el-button @click="resetSchemeSearch">
                        <i class="el-icon-refresh"></i> 重置
                     </el-button>
                  </el-form-item>
               </el-form>
            </div>

            <!-- 方案列表 -->
            <div class="scheme-list-section">
               <el-table :data="schemeList" height="400" border @row-click="handleSchemeRowClick">
                  <el-table-column label="选择" width="80" align="center">
                     <template slot-scope="scope">
                        <el-radio v-model="selectedSchemeIndex" :label="scope.$index" border size="mini">
                           <i class="el-icon-thumb"></i>
                        </el-radio>
                     </template>
                  </el-table-column>
                  <el-table-column prop="planId" label="方案编码" width="200" show-overflow-tooltip>
                     <!-- <template slot-scope="scope">
                        <a @click="toDetail(scope.row)">{{ scope.row.planId }}</a>
                     </template> -->
                  </el-table-column>
                  <el-table-column prop="planName" label="方案名称" width="200" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="planDesc" label="方案描述" min-width="200" show-overflow-tooltip></el-table-column>
                  <!-- <el-table-column prop="planType" label="促销类型" width="120" align="center">
                     <template slot-scope="scope">
                        {{ scope.row.planType == 1 ? '促销赠送' : scope.row.planType == 2 ? '促销调价' : '超量促销' }}
                     </template>
                  </el-table-column> -->
                  <el-table-column prop="state" label="方案状态" width="120" align="center">
                     <template slot-scope="scope">
                        <el-tag :type="scope.row.state == -1 ? 'danger' : scope.row.state == 0 ? 'info' : scope.row.state == 1 ? 'primary' : 'success'">
                           {{ scope.row.state == -1 ? '审核驳回' : scope.row.state == 0 ? '初始' : scope.row.state ==
                              1 ? '提交' : '审核通过' }}
                        </el-tag>
                     </template>
                  </el-table-column>
                  <el-table-column prop="startDate" label="开始日期" width="120" align="center">
                     <template slot-scope="scope">
                        {{ formatDate(scope.row.startDate) }}
                     </template>
                  </el-table-column>
                  <el-table-column prop="endDate" label="结束日期" width="120" align="center">
                     <template slot-scope="scope">
                        {{ formatDate(scope.row.endDate) }}
                     </template>
                  </el-table-column>
                  <el-table-column prop="createTime" label="创建时间" width="150" align="center">
                     <template slot-scope="scope">
                        {{ formatDateTime(scope.row.createTime) }}
                     </template>
                  </el-table-column>
               </el-table>

               <!-- 分页 -->
               <div class="pagination-section">
                  <el-pagination @size-change="handleSchemeSizeChange" @current-change="handleSchemeCurrentChange" :current-page="schemeCurrentPage" :page-sizes="[10, 20, 50, 100]" :page-size="schemePageSize"
                                 layout="total, sizes, prev, pager, next, jumper" :total="schemeTotal">
                  </el-pagination>
               </div>
            </div>
         </div>

         <div slot="footer" class="dialog-footer">
            <el-button @click="schemeDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="applySelectedScheme" :disabled="selectedSchemeIndex === null">
               应用方案
            </el-button>
         </div>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
   props: ["actionData"],
   name: "cxGiftsAction",
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      return {
         dataActionBox: {
            actionType: 0, // 0新增，1修改
         },
         checkDisabled: false,
         sendDataInfo: {
            planName: "", // 方案名称
            startDate: new Date().getTime(), // 开始日期，默认为当前日期
            endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).getTime(), // 结束日期，默认为一周后
            dayStartTime: "00:00:00", // 开始时间
            dayEndTime: "23:59:59", // 结束时间
            memReq: 1, // 会员要求 1不限 2会员卡类型 3会员积分
            planDesc: "", // 方案描述
            specialList: [], // 明细列表
            giftList: [], // 赠品列表
            couponList: [], // 优惠券列表
            conBgmTypeList: [], // 商品分类列表
            roundType: 0, // 周期类型
            roundDay: "", // 周期
            conType: 1, // 促销类型，1表示单品特价
            mzConType: 2, // 促销条件类型
            mzOrderMoney: "", // 整单金额要求
            mzConBgmNum: "", // 条件商品数量要求
            mzConBgmMoney: 0, // 条件商品金额要求
            mzBgmTypeNum: "", // 品种数量要求
            mzIsPileOther: 0, // 特价与打折是否参与 
            mzPileType: [], // 是否叠加其他促销
            mzGiftType: 1, // 促销方式，默认为赠品 
            mzIsRepeat: 0, // 是否允许重复赠送 
            mzCashBack: "", // 返现金额
            mzDiscount: "", // 折扣
            mzAddPoint: 0, // 赠送积分
            mzReducePoint: 0, // 冲减积分
            // mzGiftNum: "", // 赠送品种数量
            mzGiftNumType: 1, // 赠送品种数量类型 1任选一个 2全部赠送
            planType: 1, // 促销方案类型 促销赠送
            mzWeekDays: ['1', '2', '3', '4', '5', '6', '7'], // 促销周期
            mzMonthDays: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'], // 促销日期
            selectedCardTypeIds: [], // 选中的会员卡类型ID数组
         },
         mzPileType: [
            { label: "会员价", value: '1' },
            { label: "特价", value: '2' },
            // { label: "整单优惠", value: '3' },
            { label: "赠品", value: '4' },
            { label: "赠送优惠券", value: '5' },
            { label: "赠送积分", value: '6' },
            { label: "原品优惠", value: '7' },
            { label: "优惠价格最低品种", value: '8' },
            { label: "超量促销", value: '9' },
            { label: "优惠券", value: '10' },
         ],
         mzWeekDays: [
            { label: "周一", value: '1' },
            { label: "周二", value: '2' },
            { label: "周三", value: '3' },
            { label: "周四", value: '4' },
            { label: "周五", value: '5' },
            { label: "周六", value: '6' },
            { label: "周日", value: '7' },
         ],
         mzMonthDays: [
            { label: "1日", value: '1' },
            { label: "2日", value: '2' },
            { label: "3日", value: '3' },
            { label: "4日", value: '4' },
            { label: "5日", value: '5' },
            { label: "6日", value: '6' },
            { label: "7日", value: '7' },
            { label: "8日", value: '8' },
            { label: "9日", value: '9' },
            { label: "10日", value: '10' },
            { label: "11日", value: '11' },
            { label: "12日", value: '12' },
            { label: "13日", value: '13' },
            { label: "14日", value: '14' },
            { label: "15日", value: '15' },
            { label: "16日", value: '16' },
            { label: "17日", value: '17' },
            { label: "18日", value: '18' },
            { label: "19日", value: '19' },
            { label: "20日", value: '20' },
            { label: "21日", value: '21' },
            { label: "22日", value: '22' },
            { label: "23日", value: '23' },
            { label: "24日", value: '24' },
            { label: "25日", value: '25' },
            { label: "26日", value: '26' },
            { label: "27日", value: '27' },
            { label: "28日", value: '28' },
            { label: "29日", value: '29' },
            { label: "30日", value: '30' },
            { label: "31日", value: '31' },
         ],
         formDataList: [],
         showTabs: "",
         DialogVisible: false, //判断是否打开检索阶梯弹框
         seTitle: "", //检索阶梯的名称
         seType: "", //检索阶梯查询条件字段
         seWidth: "", //检索阶梯弹框的宽度
         sField: "", //赋值字段
         parentSearchData: {}, //检索阶梯补充的查询列表的查询条件
         selectedDataIndex: 0, // 选中的明细索引
         selectedDataIndexF: 0, // 选中的商品分类索引
         selectedGiftIndex: 0, // 选中的赠品索引
         selectedGiftRows: [], // 选中的赠品行数据
         selectedCouponIndex: 0, // 选中的优惠券索引
         detaislDataInfo: {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            maxPsprice: "",
            price: "",
            barcode: "",
            placeorigin: "",
            bgiBrand: "", // 品系名称
            itemQtyRequired: "", // 单品数量要求
            itemAmountRequired: "", // 单品金额要求
            priceSet: 1, // 价格设置类型，默认为价格不变 
         },
         giftDetailsInfo: {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            maxPsprice: "",
            barcode: "",
            placeorigin: "",
            giftNum: 1, // 赠送数量，默认为1
         },
         couponDetailsInfo: {
            yhqId: "",
            yhqName: "",
            yhqDesc: "",
            startDate: new Date().getTime(),
            endDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).getTime(),
            remark: "",
         },
         seIndex: 0, // 当前操作的明细索引
         // 会员卡类型相关数据
         cardTypeList: [], // 会员卡类型列表
         selectedCardTypes: [], // 选中的会员卡类型
         selectedCardTypeIds: [], // 选中的会员卡类型ID数组（用于复选框）

         // 门店相关数据
         storeList: [], // 门店列表
         selectedStores: [], // 选中的门店

         // 会员相关数据
         memberList: [], // 会员列表
         selectedMembers: [], // 选中的会员
         selectedMemberIds: [], // 选中的会员ID数组（用于复选框）

         // 促销条件数据
         mzConType: '按商品', // 默认促销类型
         // -----------------通用名称列表-----------------
         bgmTypeList: [],
         searchForm: {
            bgmName: '',
            manufacturer: '',
            btId: ''
         },
         shopListVisible: false,
         commonNamesList: [],
         currentPage: 1,
         pageSize: 30,
         total: 0,
         selectedCommonNames: [],
         selectedGoodsIndexSingle: null, // 单选框选中的索引（用于参与商品单选）
         goodsSelectionMode: 'multiple', // 'single' 为单选模式（参与商品），'multiple' 为多选模式（排除商品、赠品）
         allCommonNamesList: [],
         selectedAllCommonNames: false,
         allCommonNamesIds: [],
         // -----------商品分类列表相关---------------
         shopListVisibleF: false,
         commonNamesListF: [],
         currentPageF: 1,
         pageSizeF: 30,
         totalF: 0,
         selectedCategoryIndexF: null, // 单选框选中的索引
         categorySelectionMode: 'single', // 'single' 为单选模式（商品分类），'multiple' 为多选模式（赠品）
         selectedCommonNamesF: [],
         selectedAllCommonNamesF: false,
         allCommonNamesIdsF: [],
         selectedCommonNamesObjects: [], // 保存完整的选中对象

         // 优惠券列表相关
         couponListVisible: false,
         couponSearchForm: {
            yhqName: '',
            couponType: ''
         },
         couponTypeList: [],
         couponsList: [],
         couponCurrentPage: 1,
         couponPageSize: 30,
         couponTotal: 0,
         selectedCoupons: [],
         allCouponsList: [],
         selectedAllCoupons: false,
         allCouponsIds: [],

         // 当前操作类型：'special'表示添加参与商品，'gift'表示添加赠品
         currentOperationType: 'special',
         // 批号列表
         batchnoListVisible: false,
         batchnoList: [],
         selectedRowIndex: 0,
         currentBgmId: null, // 添加一个属性来存储当前操作的商品ID
         selectedBatchnoIndex: 0, // 添加一个属性来存储选中的批号索引
         currentRowData: null, // 存储当前操作的行数据

         // 促销周期和日期选择弹窗相关
         promotionDialogVisible: false,
         tempWeekDays: [], // 临时存储选中的周期
         tempMonthDays: [], // 临时存储选中的日期

         // 方案选择弹窗相关
         schemeDialogVisible: false,
         schemeList: [], // 历史方案列表
         schemeCurrentPage: 1,
         schemePageSize: 10,
         schemeTotal: 0,
         selectedSchemeIndex: 0, // 选中的方案索引
         schemeSearchForm: {
            planName: '',
            planType: ''
         },

      }
   },
   computed: {
      // 格式化开始日期显示
      formattedStartDate() {
         if (!this.sendDataInfo.startDate) return '未选择';
         return this.$moment(this.sendDataInfo.startDate).format('YYYY-MM-DD');
      },
      // 格式化结束日期显示
      formattedEndDate() {
         if (!this.sendDataInfo.endDate) return '未选择';
         return this.$moment(this.sendDataInfo.endDate).format('YYYY-MM-DD');
      },
      // 计算促销天数
      promotionDays() {
         if (!this.sendDataInfo.startDate || !this.sendDataInfo.endDate) return 0;
         const start = new Date(this.sendDataInfo.startDate);
         const end = new Date(this.sendDataInfo.endDate);
         const diffTime = Math.abs(end - start);
         const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
         return diffDays + 1; // 包含开始和结束日期
      },

      // 判断是否为不参与商品模式
      isExcludeGoodsMode() {
         return this.sendDataInfo.mzConType == 1 || this.sendDataInfo.mzConType == 3

      },



      // 会员全选状态
      isAllMembersSelected: {
         get() {
            return this.selectedMemberIds.length === this.memberList.length && this.memberList.length > 0;
         },
         set(value) {
            if (value) {
               this.selectedMemberIds = this.memberList.map(item => item.memberId);
               this.selectedMembers = [...this.memberList];
            } else {
               this.selectedMemberIds = [];
               this.selectedMembers = [];
            }
         }
      },

      // 促销周期显示文本
      weekDaysDisplayText() {
         if (!this.sendDataInfo.mzWeekDays || this.sendDataInfo.mzWeekDays.length === 0) {
            return '请选择促销周期';
         }
         const selectedLabels = this.mzWeekDays
            .filter(item => this.sendDataInfo.mzWeekDays.includes(item.value))
            .map(item => item.label);
         return selectedLabels.join('、');
      },

      // 促销日期显示文本
      monthDaysDisplayText() {
         if (!this.sendDataInfo.mzMonthDays || this.sendDataInfo.mzMonthDays.length === 0) {
            return '请选择促销日期';
         }
         const selectedLabels = this.mzMonthDays
            .filter(item => this.sendDataInfo.mzMonthDays.includes(item.value))
            .map(item => item.label);
         return selectedLabels.join('、');
      },

   },
   watch: {
      'sendDataInfo.mzIsPileOther': {
         handler(newVal) {
            if (newVal == 0) {
               // 当特价与打折参与设置为"否"时，清空叠加其他促销的选择
               this.sendDataInfo.mzPileType = [];
            }
         },
         immediate: true
      },
      'shopListVisible': {
         handler(newVal) {
            if (!newVal) {
               // 当对话框关闭时，清空选中状态
               this.selectedCommonNames = [];
               this.selectedAllCommonNames = false;
               this.allCommonNamesList = [];
               this.allCommonNamesIds = [];
               // 重置操作类型
               this.currentOperationType = 'special';
            }
         }
      },
      'couponListVisible': {
         handler(newVal) {
            if (!newVal) {
               // 当对话框关闭时，清空选中状态
               this.selectedCoupons = [];
               this.selectedAllCoupons = false;
               this.allCouponsList = [];
               this.allCouponsIds = [];
            }
         }
      }
   },
   methods: {

      async getTypeList() {
         let responseData = await this.$http.getTypeList({
            businessId: "",
            creater: 0,
            ormId: 0,
            page: 1,
            rows: 50,
            start: "",
            end: "",
            btName: "",

         })
         if (responseData.status == 200) {
            this.bgmTypeList = responseData.result.list
         }
      },
      async openBox() {
         if (this.actionData.limit == 13) {
            // 满赠促销
            this.sendDataInfo.mzConType = 2
         } else if (this.actionData.limit == 14) {
            // 整单促销
            this.sendDataInfo.mzConType = 1
            this.sendDataInfo.mzIsPileOther = 1
            this.sendDataInfo.mzPileType = ['1', '2']
         } else if (this.actionData.limit == 15) {
            // 组合促销
            this.sendDataInfo.mzConType = 3
         }
         if (this.actionData.cate == 0) {
            this.showTabs = "新增"
            this.formDataList = [
               {
                  jciName: "新增",
                  jurconfigform: [],
               },
            ]
         } else {
            // 回显数据
            console.log(this.actionData.oldData, 'this.actionData.oldData');
            this.checkDisabled = this.actionData?.checkDisabled ? true : false
            console.log(this.checkDisabled, 'this.checkDisabled');

            if (this.actionData.oldData) {
               for (let key in this.actionData.oldData) {
                  // 特殊处理周期类型
                  if (key === "roundWeek") {
                     const roundWeek = this.actionData.oldData[key].split(',');
                     this.sendDataInfo.mzWeekDays = roundWeek;
                  } else if (key === "roundDay") {
                     const roundDay = this.actionData.oldData[key].split(',');
                     this.sendDataInfo.mzMonthDays = roundDay;
                  } else if (key === "mzPileType") {
                     this.sendDataInfo.mzPileType = this.actionData.oldData[key].split(',');
                  } else if (key === "dayStartTime" || key === "dayEndTime") {
                     // 特殊处理每日时间字段，将秒数转换为时间字符串
                     const seconds = this.actionData.oldData[key];
                     if (seconds !== null && seconds !== undefined && seconds !== "") {
                        const hours = Math.floor(seconds / 3600);
                        const minutes = Math.floor((seconds % 3600) / 60);
                        const secs = seconds % 60;
                        const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
                        this.$set(this.sendDataInfo, key, timeString);
                     } else {
                        this.$set(this.sendDataInfo, key, "");
                     }
                  } else {
                     this.$set(this.sendDataInfo, key, this.actionData.oldData[key])
                  }
               }
               console.log(this.actionData.oldData.conBgmTypeList, 'this.actionData.oldData.conBgmTypeList');

               // 回显商品分类数据
               if (this.actionData.oldData.conBgmTypeList && this.actionData.oldData.conBgmTypeList.length > 0) {
                  this.sendDataInfo.conBgmTypeList = this.actionData.oldData.conBgmTypeList.map(item => ({
                     btId: item.btId || "",
                     btName: item.btName || "",
                     btDesc: item.btDesc || "",
                     num: item.num || "",
                     money: item.money || "",
                     priceSet: item.priceSet || 1,
                     remark: item.remark || "",
                  }));
               }
               console.log(this.actionData.oldData.banBgmList, 'this.actionData.oldData.banBgmList');

               // 回显不参与的商品列表
               if (this.actionData.oldData.banBgmList && this.actionData.oldData.banBgmList.length > 0) {
                  this.sendDataInfo.specialList = this.actionData.oldData.banBgmList.map(item => ({
                     bgmId: item.bgmId || "",
                     bgmName: item.bgmName || "",
                     bgmCode: item.bgmCode || "",
                     bgmSpec: item.bgmSpec || "",
                     spec: item.spec || "",
                     manufacturer: item.manufacturer || "",
                     barcode: item.barcode || "",
                     placeorigin: item.placeorigin || "",
                     retailPrice: item.retailPrice || "",
                     maxPsprice: item.maxPsprice || "",
                  }));
               }
               // 回显赠品数据
               if (this.actionData.oldData.conBgmList && this.actionData.oldData.conBgmList.length > 0) {
                  this.sendDataInfo.specialList = this.actionData.oldData.conBgmList.map(item => ({
                     bgmId: item.bgmId || "",
                     bgmName: item.bgmName || "",
                     bgmCode: item.bgmCode || "",
                     bgmSpec: item.bgmSpec || "",
                     spec: item.spec || "",
                     manufacturer: item.manufacturer || "",
                     barcode: item.barcode || "",
                     placeorigin: item.placeorigin || "",
                     retailPrice: item.retailPrice || "",
                     maxPsprice: item.maxPsprice || "",
                     itemQtyRequired: item.num || "",
                     itemAmountRequired: item.money || "",
                     priceSet: item.priceSet || 1,

                  }));
                  console.log(this.sendDataInfo.specialList, 'this.sendDataInfo.specialList');

               }

               // 回显赠品赠送列表
               if (this.actionData.oldData.giftBgmList && this.actionData.oldData.giftBgmList.length > 0) {
                  this.sendDataInfo.giftList = this.actionData.oldData.giftBgmList.map(item => ({
                     bgmId: item.bgmId || "",
                     bgmName: item.bgmName || "",
                     bgmCode: item.bgmCode || "",
                     bgmSpec: item.bgmSpec || "",
                     spec: item.spec || "",
                     manufacturer: item.manufacturer || "",
                     barcode: item.barcode || "",
                     placeorigin: item.placeorigin || "",
                     retailPrice: item.retailPrice || "",
                     maxPsprice: item.maxPsprice || "",
                     price: Number(item.price) || "",
                     giftNum: item.giftNum || "",
                     batchno: item.batchno || "",

                  }));
               }

               // 回显优惠券列表
               if (this.actionData.oldData.giftYhqList && this.actionData.oldData.giftYhqList.length > 0) {
                  this.sendDataInfo.couponList = this.actionData.oldData.giftYhqList.map(item => ({
                     yhqId: item.yhqId || "",
                     yhqName: item.yhqName || "",
                     yhqDesc: item.yhqDesc || "",
                     limitDay: item.limitDay || "",
                     remark: item.remark || "",
                     giftNum: item.giftNum || "",
                  }));
               }

               // 回显会员卡类型和门店选择
               this.$nextTick(async () => {
                  // 回显会员卡类型选择
                  if (this.actionData.oldData.mcTypeList && this.actionData.oldData.mcTypeList.length > 0) {
                     await this.loadCardTypeData();
                     // 获取所有需要选中的卡类型ID
                     const selectedIds = this.actionData.oldData.mcTypeList.map(item => item.capId);
                     // 设置选中状态
                     this.selectedCardTypeIds = selectedIds;
                     this.sendDataInfo.selectedCardTypeIds = selectedIds;
                     // 设置选中的对象数组
                     this.selectedCardTypes = this.cardTypeList.filter(item => selectedIds.includes(item.capId));

                     // 使用 nextTick 确保表格已渲染完成
                     await this.$nextTick();
                     // 设置表格选中状态
                     if (this.$refs.cardTypeTable) {
                        this.selectedCardTypes.forEach(item => {
                           this.$refs.cardTypeTable.toggleRowSelection(item, true);
                        });
                     }

                  }

                  // 回显门店选择

                  if (this.actionData.oldData.storeList && this.actionData.oldData.storeList.length > 0) {
                     await this.loadStoreData();
                     await this.$nextTick();
                     setTimeout(() => {
                        const selectedStoreIds = this.actionData.oldData.storeList;
                        console.log(this.storeList, 'this.storeList');
                        // 确保 storeTable 存在
                        if (this.$refs.storeTable) {
                           this.storeList.forEach(item => {
                              const itemId = item.id || item.storeId;
                              // 检查是否存在匹配的门店ID
                              const isSelected = selectedStoreIds.some(store =>
                                 (store.id === itemId || store.storeId === itemId)
                              );
                              if (isSelected) {
                                 this.$refs.storeTable.toggleRowSelection(item, true);
                              }
                           });
                        }
                     }, 200);

                  }
               })
            }

            this.formDataList = [
               {
                  jciName: "编辑",
                  jurconfigform: [],
               },
            ]
            this.showTabs = "编辑"
         }

         this.dataActionBox.actionType = this.actionData.cate
         this.init()

      },
      // 初始化数据
      init() {
         // 只有在新增模式下才清空明细数据
         if (this.dataActionBox.actionType == 0) {
            this.sendDataInfo.specialList = [];
            this.sendDataInfo.giftList = [];
            this.sendDataInfo.couponList = [];
            this.sendDataInfo.roundDay = "";
            this.memDayIds = [];
            // 设置默认日期
            this.sendDataInfo.startDate = new Date().getTime(); // 当前日期
            this.sendDataInfo.endDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).getTime(); // 一周后
         }

         // 初始化明细默认数据
         this.detaislDataInfo = {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            maxPsprice: "",
            price: "",
            barcode: "",
            placeorigin: "",
            bgiBrand: "", // 品系名称
            itemQtyRequired: "", // 单品数量要求
            itemAmountRequired: "", // 单品金额要求
            priceSet: 1, // 价格设置类型，默认为价格不变
            mzIsPileOther: 0, // 特价与打折是否参与
         };

         // 初始化赠品默认数据
         this.giftDetailsInfo = {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            maxPsprice: "",
            barcode: "",
            placeorigin: "",
            giftNum: 1, // 赠送数量，默认为1
         };

         // 初始化优惠券默认数据
         this.couponDetailsInfo = {
            yhqId: "",
            yhqName: "",
            description: "",
            startDate: new Date().getTime(),
            endDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).getTime(),
            remark: "",
         };

         // 加载会员卡类型、会员和门店数据
         this.loadCardTypeData();
         // this.loadMemberData();
         this.loadStoreData();
      },
      // 新增明细
      addDetails() {
         // 检查是否为参与商品模式且已有数据
         if (!this.isExcludeGoodsMode && this.sendDataInfo.specialList.length >= 1) {
            this.$message({
               message: "参与商品列表只能添加一条数据",
               type: "warning"
            });
            return;
         }

         this.currentOperationType = 'special'

         // 根据是否为排除商品模式设置选择模式
         if (this.isExcludeGoodsMode) {
            this.goodsSelectionMode = 'multiple'; // 排除商品模式：多选
         } else {
            this.goodsSelectionMode = 'single';   // 参与商品模式：单选
         }

         this.selectedGoodsIndexSingle = null; // 重置单选状态
         this.searchCommonNames()
         this.shopListVisible = true

      },
      // 删除明细
      deleteDetails() {
         if (this.sendDataInfo.specialList.length > 0) {
            this.sendDataInfo.specialList.splice(this.selectedDataIndex, 1);
            this.selectedDataIndex = 0;
         } else {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }
      },
      // 新增商品分类
      addFDetails() {
         // 设置为单选模式
         this.categorySelectionMode = 'single';
         this.selectedCategoryIndexF = null; // 重置选择状态
         this.searchForm = {}
         this.searchCommonNamesF()
         this.shopListVisibleF = true
      },
      // 删除商品分类
      deleteFDetails() {
         if (this.sendDataInfo.conBgmTypeList.length > 0) {
            this.sendDataInfo.conBgmTypeList.splice(this.selectedDataIndex, 1);
            this.selectedDataIndex = 0;
         } else {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.specialList[index + 1] != undefined) {
               // 根据促销类型选择焦点字段
               const focusField = this.sendDataInfo.conType == 2 ? "bgiBrand" : "bgmName";
               if (this.$refs[focusField] && this.$refs[focusField][index + 1]) {
                  this.$refs[focusField][index + 1].focus();
               }
               this.selectedDataIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  if (refsElTable) {
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.specialList[this.selectedDataIndex]
                     );
                  }
               });
               return;
            }
            this.addDetails();
            return;
         }
         // 根据促销类型选择焦点字段
         const focusField = this.sendDataInfo.conType == 2 ? "bgiBrand" : field;
         if (this.$refs[focusField] && this.$refs[focusField][index]) {
            this.$refs[focusField][index].focus();
         }
      },
      // 双击明细行
      openDateilsBox(row, column, event) {
         this.editDateilsIndex = row.index;
         this.specialList = JSON.parse(JSON.stringify(row));
      },
      handleRowGiftClick(row) {
         console.log(row, 'rowGift');
         this.selectedGiftIndex = this.sendDataInfo.giftList.findIndex(item => item.bgmId === row.bgmId)
      },
      handleRowClick(row) {
         console.log(row, 'row');
         this.selectedDataIndex = this.sendDataInfo.specialList.findIndex(item => item.bgmId === row.bgmId)
      },
      //获取检索阶梯弹框宽度
      getSeWidth(e) {
         this.seWidth = e + "%"
      },
      //获取检索阶梯弹框名称
      getSearchName(e) {
         this.seTitle = e
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.seId = sId //检索阶梯Id
         this.sField = sField //赋值字段
         this.DialogVisible = true //判断是否打开弹框
         this.seType = type
         this.seIndex = index // 设置当前操作的明细索引
         console.log('openSearch - seIndex:', this.seIndex, 'seType:', this.seType);
      },
      //检索阶梯返回的数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false
            console.log('changeInputModel - seType:', this.seType, 'seIndex:', this.seIndex, 'val:', val);

            if (this.seType == "bgmName") {
               // 处理商品搜索返回的数据
               if (this.seIndex !== undefined) {
                  // 第一个表单
                  console.log('处理第一个表单，索引:', this.seIndex);
                  for (let fkey in this.sendDataInfo.specialList[this.seIndex]) {
                     for (let vkey in val) {
                        if (fkey == vkey) {
                           this.$set(
                              this.sendDataInfo.specialList[this.seIndex],
                              fkey,
                              val[vkey]
                           );
                        }
                     }
                  }
                  // 设置商品相关信息
                  this.sendDataInfo.specialList[this.seIndex].bgmId = val.bgmId;
                  this.sendDataInfo.specialList[this.seIndex].bgmName = val.bgmName;
                  this.sendDataInfo.specialList[this.seIndex].bgmCode = val.bgmCode;
                  this.sendDataInfo.specialList[this.seIndex].bgmSpec = val.bgmSpec;
                  this.sendDataInfo.specialList[this.seIndex].spec = val.spec;
                  this.sendDataInfo.specialList[this.seIndex].manufacturer = val.manufacturer;
                  this.sendDataInfo.specialList[this.seIndex].retailPrice = val.retailPrice;
                  this.sendDataInfo.specialList[this.seIndex].maxPsprice = val.maxPsprice;
                  this.sendDataInfo.specialList[this.seIndex].price = val.price;
                  this.sendDataInfo.specialList[this.seIndex].barcode = val.barcode;
                  this.sendDataInfo.specialList[this.seIndex].placeorigin = val.placeorigin;
                  this.sendDataInfo.specialList[this.seIndex].itemQtyRequired = "";
                  this.sendDataInfo.specialList[this.seIndex].itemAmountRequired = "";
                  this.sendDataInfo.specialList[this.seIndex].priceSet = 1;
                  this.sendDataInfo.specialList[this.seIndex].mzIsPileOther = 0;
               }
            } else if (this.seType == "yhqName") {
               // 处理优惠券搜索返回的数据
               if (this.seIndex !== undefined) {
                  for (let fkey in this.sendDataInfo.couponList[this.seIndex]) {
                     for (let vkey in val) {
                        if (fkey == vkey) {
                           this.$set(
                              this.sendDataInfo.couponList[this.seIndex],
                              fkey,
                              val[vkey]
                           );
                        }
                     }
                  }
                  // 设置优惠券相关信息
                  this.sendDataInfo.couponList[this.seIndex].yhqId = val.yhqId;
                  this.sendDataInfo.couponList[this.seIndex].yhqName = val.yhqName;
                  this.sendDataInfo.couponList[this.seIndex].yhqDesc = val.yhqDesc || '';
                  this.sendDataInfo.couponList[this.seIndex].startDate = val.startDate || new Date().getTime();
                  this.sendDataInfo.couponList[this.seIndex].endDate = val.endDate || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).getTime();
                  this.sendDataInfo.couponList[this.seIndex].remark = val.remark || '';
                  this.sendDataInfo.couponList[this.seIndex].giftNum = val.giftNum || 1;
                  this

               }
            } else {
               this.paramValue(val) //赋值字段，赋值
            }
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",")
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item]
         })
      },
      //关闭提取、检索阶梯弹框关闭 创建键盘事件
      closeChild() {
         addEventListener("keyup", this.keyUp) //创建监听键盘事件
      },
      async sendDataAction() {

         // 表单验证
         this.$refs.sendDataInfo.validate(async (valid) => {
            if (valid) {
               // 验证开始日期和结束日期
               if (this.sendDataInfo.startDate && this.sendDataInfo.endDate) {
                  if (this.sendDataInfo.endDate < this.sendDataInfo.startDate) {
                     this.$message({
                        message: "结束日期不能小于开始日期",
                        type: "error",
                     });
                     return false;
                  }
                  // 处理开始日期和结束日期，去掉时分秒
                  const startDate = new Date(this.sendDataInfo.startDate);
                  const endDate = new Date(this.sendDataInfo.endDate);

                  // 设置时间为当天的 00:00:00
                  startDate.setHours(0, 0, 0, 0);
                  endDate.setHours(0, 0, 0, 0);

                  // 更新时间戳
                  this.sendDataInfo.startDate = startDate.getTime();
                  this.sendDataInfo.endDate = endDate.getTime();
               }

               // 验证促销方式相关
               switch (this.sendDataInfo.mzGiftType) {
                  case '1':
                     // 如果选择了赠品促销方式，验证是否添加了赠品
                     if (!this.sendDataInfo.giftList || this.sendDataInfo.giftList.length === 0) {
                        this.$message({
                           message: "请添加至少一个赠品商品",
                           type: "error",
                        });

                        return false;

                     }
                  case '5':
                     // 验证返现金额
                     if (this.sendDataInfo.mzCashBack === "") {
                        this.$message({
                           message: "请输入返现金额",
                           type: "error",
                        });
                        return false;
                     }
                     break;

                  case '4':
                     // 验证折扣
                     if (this.sendDataInfo.mzDiscount === "") {
                        this.$message({
                           message: "请输入折扣",
                           type: "error",
                        });
                        return false;
                     }
                     break;


               }

               // 验证每日开始时间和每日结束时间
               if (this.sendDataInfo.dayStartTime && this.sendDataInfo.dayEndTime) {
                  // 直接处理时间字符串格式 HH:mm:ss
                  const startParts = this.sendDataInfo.dayStartTime.split(':');
                  const endParts = this.sendDataInfo.dayEndTime.split(':');

                  const startHours = parseInt(startParts[0]) || 0;
                  const startMinutes = parseInt(startParts[1]) || 0;
                  const startSeconds = parseInt(startParts[2]) || 0;

                  const endHours = parseInt(endParts[0]) || 0;
                  const endMinutes = parseInt(endParts[1]) || 0;
                  const endSeconds = parseInt(endParts[2]) || 0;

                  // 转换为秒数进行比较
                  const startTotalSeconds = startHours * 3600 + startMinutes * 60 + startSeconds;
                  const endTotalSeconds = endHours * 3600 + endMinutes * 60 + endSeconds;

                  if (endTotalSeconds <= startTotalSeconds) {
                     this.$message({
                        message: "每日结束时间不能小于或等于每日开始时间",
                        type: "error",
                     });
                     return false;
                  }
               }

               // 验证积分要求
               if (this.sendDataInfo.memReq == 3 && (!this.sendDataInfo.memReqPoint)) {
                  this.$message({
                     message: "请填写积分要求",
                     type: "error",
                  });
                  return false;
               }

               // 验证会员卡类型选择
               if (this.sendDataInfo.memReq == 2 && this.selectedCardTypes.length === 0) {
                  this.$message({
                     message: "请选择至少一个会员卡类型",
                     type: "error",
                  });
                  return false;
               }

               // 赠品批号判断
               // if (this.sendDataInfo.mzGiftType == 1 && this.sendDataInfo.giftList.length > 0) {
               //    let batchnoBoolean = true
               //    this.sendDataInfo.giftList.forEach((item) => {
               //       if (!item.batchno || item.batchno == '') {
               //          batchnoBoolean = false
               //       }
               //    })
               //    if (!batchnoBoolean) {
               //       this.$message({
               //          message: "请填写赠品批号",
               //          type: "error",
               //       });
               //       return batchnoBoolean;
               //    }

               // }


               // 验证促销条件
               if (this.sendDataInfo.mzConType == 1 && !this.sendDataInfo.mzOrderMoney) {
                  this.$message({
                     message: "请输入整单金额要求",
                     type: "error",
                  });
                  return false;
               }

               // 按商品促销类型需要验证条件商品数量
               if (this.sendDataInfo.mzConType == 2 && !this.sendDataInfo.mzConBgmNum) {
                  this.$message({
                     message: "请输入条件商品数量要求",
                     type: "error",
                  });
                  return false;
               }

               // 按商品分类促销类型需要验证条件商品数量
               if (this.sendDataInfo.mzConType == 2 && !this.sendDataInfo.mzConBgmNum) {
                  this.$message({
                     message: "请输入条件商品数量要求",
                     type: "error",
                  });
                  return false;
               }


               // 按商品促销类型需要验证商品列表
               if (this.sendDataInfo.mzConType == 2 && this.sendDataInfo.specialList.length === 0) {
                  this.$message({
                     message: "请添加参与促销的商品",
                     type: "error",
                  });
                  return false;
               }

               // 使用 for 循环检查药品是否加价了
               for (let i = 0; i < this.sendDataInfo.giftList.length; i++) {
                  if (this.sendDataInfo.giftList[i].goodType == 0) {
                     const price = this.sendDataInfo.giftList[i].price;
                     console.log(price, 'price');
                     if (price <= 0 || price == null || price == undefined || price == "") {
                        this.$message({
                           message: `${this.sendDataInfo.giftList[i].bgmName}药品加价不能为0或为空`,
                           type: "error",
                        });
                        return false;
                     }
                  }
               }

               // ------------------处理参数------------------
               //会员要求：会员卡类型
               if (this.sendDataInfo.memReq == 2) {
                  this.sendDataInfo.mcTypeList = this.selectedCardTypes.map(item => {
                     return item.capId
                  })
               }


               if (this.sendDataInfo.mzConType == 1) {
                  // 不可参与商品
                  this.sendDataInfo.banBgmList = this.sendDataInfo.specialList.map(item => item.bgmId)
               } else if (this.sendDataInfo.mzConType == 2) {
                  this.sendDataInfo.conBgmList = this.sendDataInfo.specialList.map(item => {
                     return {
                        bgmId: item.bgmId,
                        money: Number(item.itemAmountRequired),
                        num: Number(item.itemQtyRequired),
                        priceSet: Number(item.priceSet),
                     }
                  })
               } else if (this.sendDataInfo.mzConType == 3) {
                  console.log(this.sendDataInfo.conBgmTypeList, 'this.sendDataInfo.conBgmTypeList');

                  this.sendDataInfo.banBgmList = this.sendDataInfo.specialList.map(item => item.bgmId)
                  this.sendDataInfo.conBgmTypeList = this.sendDataInfo.conBgmTypeList.map(item => {
                     return {
                        btId: item.btId,
                        num: Number(item.num),
                        money: Number(item.money),
                        priceSet: Number(item.priceSet),
                     }
                  })
               }

               if (this.sendDataInfo.mzGiftType == 1) {
                  this.sendDataInfo.giftBgmList = this.sendDataInfo.giftList.map(item => {
                     return {
                        bgmId: item.bgmId,
                        giftNum: item.giftNum,
                        batchno: item.batchno || "",
                        price: Number(item.price) || "",
                     }
                  })
               } else if (this.sendDataInfo.mzGiftType == 2) {
                  // 赠送优惠券列表
                  this.sendDataInfo.giftYhqList = this.sendDataInfo.couponList.map(item => {
                     return {
                        yhqId: item.yhqId,
                        giftNum: item.giftNum,
                     }

                  })
               }

               console.log(this.sendDataInfo, "this.sendDataInfo");

               let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))

               // 日期周期（数字逗号隔开）
               sendData.roundDay = this.sendDataInfo.mzMonthDays ? this.sendDataInfo.mzMonthDays.join(',') : ''
               // 星期周期（数字逗号隔开）
               sendData.roundWeek = this.sendDataInfo.mzWeekDays ? this.sendDataInfo.mzWeekDays.join(',') : ''
               // 是否叠加其他促销（数字逗号隔开）

               sendData.mzPileType = this.sendDataInfo.mzPileType ? this.sendDataInfo.mzPileType.join(',') : ''
               console.log(this.selectedStores, 'this.selectedStores');

               // 门店id列表
               try {
                  sendData.storeIdList = this.selectedStores && this.selectedStores.length > 0 ?
                     this.selectedStores.map(item => item.id || item.storeId) : []
               } catch (error) {

               }



               // 处理每日开始时间和每日结束时间，转换为秒数
               if (sendData.dayStartTime) {
                  // 将时间字符串转换为秒数
                  const timeParts = sendData.dayStartTime.split(':');
                  const hours = parseInt(timeParts[0]) || 0;
                  const minutes = parseInt(timeParts[1]) || 0;
                  const seconds = parseInt(timeParts[2]) || 0;
                  sendData.dayStartTime = hours * 3600 + minutes * 60 + seconds;
               }

               if (sendData.dayEndTime) {
                  // 将时间字符串转换为秒数
                  const timeParts = sendData.dayEndTime.split(':');
                  const hours = parseInt(timeParts[0]) || 0;
                  const minutes = parseInt(timeParts[1]) || 0;
                  const seconds = parseInt(timeParts[2]) || 0;
                  sendData.dayEndTime = hours * 3600 + minutes * 60 + seconds;
               }
               // showType 判断什么类型促销
               if (this.actionData.limit == 11) {
                  sendData.showType = 11
               } else if (this.actionData.limit == 12) {
                  sendData.showType = 12
               } else if (this.actionData.limit == 13) {
                  sendData.showType = 13
               } else if (this.actionData.limit == 14) {
                  sendData.showType = 14
               } else if (this.actionData.limit == 15) {
                  sendData.showType = 15
               } else if (this.actionData.limit == 16) {
                  sendData.showType = 16
               }
               try {
                  let responseData
                  // 如果是新增
                  if (this.dataActionBox.actionType == 0) {
                     responseData = await this.$http.addSellPlan(sendData)
                  }
                  // 如果是编辑
                  else if (this.dataActionBox.actionType == 1) {
                     responseData = await this.$http.updateSellPlan(sendData)
                  }

                  if (responseData.status == 200) {
                     this.$message({
                        message:
                           this.dataActionBox.actionType == 0 ? "新增成功" : "编辑成功",
                        type: "success",
                     })
                     this.$emit("drawerCancel", false)
                     this.$emit("toDetail", responseData.result)
                  } else {
                     this.$message({
                        message: responseData.message,
                        type: "error",
                     })
                  }
               } catch (error) {
                  console.error("error", error)
                  this.$message({
                     message: "操作失败",
                     type: "error",
                  })
               }
            } else {
               this.$message({
                  message: "请填写必填项",
                  type: "error",
               })
               return false
            }
         })
      },
      drawerCancel() {
         if (this.checkDisabled) {
            this.$emit("drawerCancel", false)
         } else {
            this.$confirm("确认关闭弹窗吗？未保存的数据将丢失。", "提示", {
               confirmButtonText: "确定",
               cancelButtonText: "取消",
               type: "warning",
            })
               .then(() => {
                  this.$emit("drawerCancel", false)
               })
               .catch(() => { })
         }

      },

      // 会员卡类型选择变化（右侧表格）
      handleCardTypeSelectionChange(selection) {
         this.selectedCardTypes = selection;
         // 同步更新复选框选中的ID
         this.selectedCardTypeIds = selection.map(item => item.capId);
         // 同步更新 sendDataInfo 中的字段
         this.sendDataInfo.selectedCardTypeIds = selection.map(item => item.capId);
      },

      // 门店选择变化
      handleStoreSelectionChange(selection) {
         console.log(selection, 'selection');

         this.selectedStores = selection;
      },
      handleStoreClick(row) {
         this.$refs.storeTable.toggleRowSelection(row);
      },
      // 会员要求变化处理
      handleMemberTypeChange() {
         // 当会员要求不是"会员积分"时，清空积分要求字段
         if (this.sendDataInfo.memReq !== 3) {
            this.sendDataInfo.memReqPoint = '';
         }
         // 当会员要求不是"会员卡类型"时，清空会员卡类型选择
         if (this.sendDataInfo.memReq !== 2) {
            this.selectedCardTypeIds = [];
            this.selectedCardTypes = [];
            this.sendDataInfo.selectedCardTypeIds = [];
         }
         // 当会员要求不是"会员"时，清空会员选择
         if (this.sendDataInfo.memReq !== 1) {
            this.selectedMemberIds = [];
            this.selectedMembers = [];
         }
      },

      // 促销类型变化处理
      handlePromotionTypeChange(value) {
         // 清空商品列表
         this.sendDataInfo.specialList = [];

         // 重置特价与打折参与设置
         this.sendDataInfo.mzIsPileOther = '0';

         if (value == 1) {
            // 清空其他条件，只保留整单金额
            this.sendDataInfo.mzConBgmNum = '';
            this.sendDataInfo.mzConBgmMoney = 0;
            this.sendDataInfo.mzBgmTypeNum = '';
            this.sendDataInfo.goodsCategory = '';
            this.sendDataInfo.mzPileType = [];
         } else if (value == 2) {
            // 按商品促销时，清空整单金额
            this.sendDataInfo.mzOrderMoney = '';
            this.sendDataInfo.goodsCategory = '';
            // 确保其他条件可用
            if (!this.sendDataInfo.mzConBgmNum) this.sendDataInfo.mzConBgmNum = '';
            if (!this.sendDataInfo.mzConBgmMoney) this.sendDataInfo.mzConBgmMoney = 0;
            if (!this.sendDataInfo.mzBgmTypeNum) this.sendDataInfo.mzBgmTypeNum = '';
            this.sendDataInfo.mzPileType = [];
         } else if (value == 3) {
            console.log('按商品分类', 888);
            // 按商品促销时，清空整单金额
            this.sendDataInfo.mzOrderMoney = '';
            this.sendDataInfo.goodsCategory = '';
            this.sendDataInfo.mzConBgmNum = '';
            this.sendDataInfo.mzConBgmMoney = 0;
            this.sendDataInfo.mzBgmTypeNum = '';
            this.sendDataInfo.goodsCategory = '';
            this.sendDataInfo.mzPileType = [];
         }
         // 更新表单验证规则
         this.$nextTick(() => {
            if (this.$refs.sendDataInfo) {
               this.$refs.sendDataInfo.clearValidate();
            }
         });
      },

      // 会员卡类型复选框变化处理
      handleCardTypeCheckboxChange() {
         // 由于现在使用单独的复选框，selectedCardTypeIds已经通过v-model自动更新
         this.selectedCardTypes = this.cardTypeList.filter(item => this.selectedCardTypeIds.includes(item.capId));
      },
      handleCardTypeClick(capId) {
         const idx = this.selectedCardTypeIds.indexOf(capId);
         if (idx > -1) {
            // 已选中，取消选中
            this.selectedCardTypeIds.splice(idx, 1);
         } else {
            // 未选中，添加选中
            this.selectedCardTypeIds.push(capId);
         }
         // 同步更新选中的对象数组
         this.selectedCardTypes = this.cardTypeList.filter(item => this.selectedCardTypeIds.includes(item.capId));
      },
      // 处理单个会员卡类型复选框变化
      handleSingleCardTypeChange(capId, checked) {
         if (checked) {
            if (!this.selectedCardTypeIds.includes(capId)) {
               this.selectedCardTypeIds.push(capId);
            }
         } else {
            const index = this.selectedCardTypeIds.indexOf(capId);
            if (index > -1) {
               this.selectedCardTypeIds.splice(index, 1);
            }
         }
         this.selectedCardTypes = this.cardTypeList.filter(item => this.selectedCardTypeIds.includes(item.capId));
      },







      // 加载会员卡类型数据
      async loadCardTypeData() {
         try {
            let res = await this.$http.queryMemCardType({
               businessId: "",
               creater: 0,
               ormId: 0,
               page: 1,
               rows: 100,
               start: "",
               end: "",
               capName: "",
            })

            if (res.status == 200) {
               this.cardTypeList = res.result.list || []

            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         } catch (error) {
            this.$message({
               message: '获取会员卡类型数据失败',
               type: "error",
            })
         }
      },

      // 加载会员数据
      async loadMemberData() {
         try {
            let res = await this.$http.queryMembermastList({
               businessId: "",
               creater: 0,
               ormId: 0,
               page: 1,
               rows: 1000,
               start: "",
               end: "",
               memName: "",
               memPhone: ""

            })

            if (res.status == 200) {
               this.memberList = res.result.list || []
            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         } catch (error) {
            this.$message({
               message: '获取会员数据失败',
               type: "error",
            })
         }
      },

      // 加载门店数据
      async loadStoreData() {
         try {
            let res = await this.$http.storemastQueryAll({
               businessId: "",
               creater: 0,
               end: 0,
               ormId: 0,
               page: 1,
               rows: 1000,
               start: 0,
               storeName: "",
               storeType: ""
            })

            if (res.status == 200) {
               this.storeList = res.result || []
            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         } catch (error) {
            this.$message({
               message: '获取门店数据失败',
               type: "error",
            })
         }
      },

      // 获取价格设置显示文本
      getPriceSettingText(type) {
         const typeMap = {
            1: '价格不变',
            2: '全部恢复原价',
            3: '数量要求部分恢复原价'
         };
         return typeMap[type] || '';
      },

      // 处理促销方式变化
      handlePromotionMethodChange(value) {
         // 重置所有相关字段
         this.sendDataInfo.mzIsRepeat = 0;
         this.sendDataInfo.mzCashBack = "";
         this.sendDataInfo.mzDiscount = "";
         this.sendDataInfo.mzAddPoint = 0;
         this.sendDataInfo.mzReducePoint = 0;
         this.sendDataInfo.mzGiftNumType = 1;

         // 根据不同促销方式设置字段默认值或显示状态
         switch (value) {
            case '5':
               // 原品金额减免，只启用返现金额字段
               this.sendDataInfo.mzCashBack = "0";
               break;
            case '4':
               // 原品打折，只启用折扣字段
               this.sendDataInfo.mzDiscount = "0";
               break;
            case '3':
               // 原品金额减免积分，只启用赠送积分字段
               this.sendDataInfo.mzAddPoint = 0;
               break;
            case '1':
               break;
            case '2':
               // 赠品和优惠券，启用冲减积分和赠送品种类型字段
               this.sendDataInfo.mzReducePoint = 0;
               this.sendDataInfo.mzGiftNumType = 1;
               break;
            default:
               break;
         }
      },

      // 添加赠品
      addGiftDetails() {
         this.currentOperationType = 'gift'
         this.goodsSelectionMode = 'multiple'; // 赠品选择：多选模式
         this.searchForm = {}
         this.searchCommonNames()
         this.shopListVisible = true
      },

      // 处理赠品表格选择变化
      handleGiftSelectionChange(selection) {
         this.selectedGiftRows = selection;
      },
      // 删除赠品
      deleteGiftDetails() {
         if (this.selectedGiftRows.length === 0) {
            return this.$message({
               message: "请选择要删除的赠品",
               type: "warning",
            });
         }

         // 获取选中行的索引
         const selectedIds = this.selectedGiftRows.map(row => row.bgmId);

         // 从后向前删除，避免索引变化问题
         const newGiftList = this.sendDataInfo.giftList.filter(item => !selectedIds.includes(item.bgmId));
         this.sendDataInfo.giftList = newGiftList;

         this.$message({
            message: `已删除 ${this.selectedGiftRows.length} 个赠品`,
            type: "success",
         });

         // 清空选择
         this.selectedGiftRows = [];
         if (this.$refs.giftTableRef) {
            this.$refs.giftTableRef.clearSelection();
         }
      },

      // 双击赠品行
      openGiftDetailsBox(row, column, event) {
         this.editGiftDetailsIndex = row.index;
         this.giftList = JSON.parse(JSON.stringify(row));
      },
      batchnoClick(row) {
         console.log('点击批号按钮:', row);

         // 先清空之前的批号列表和状态
         this.batchnoList = [];
         this.selectedBatchnoIndex = 0;

         // 存储当前操作的行数据
         this.currentRowData = row;

         // 存储当前操作的行索引，用于后续回显批号
         const currentRowIndex = this.sendDataInfo.giftList.findIndex(item => item.bgmId === row.bgmId);
         if (currentRowIndex !== -1) {
            // 保存当前操作的行索引
            this.selectedRowIndex = currentRowIndex; // 保存表格中的行索引
         } else {
            console.error('未找到对应的行索引');
            this.$message({
               type: 'error',
               message: '未找到对应的商品行'
            });
            return;
         }

         // 显示加载提示
         const loading = this.$loading({
            lock: true,
            text: '正在加载批号数据...',
            spinner: 'el-icon-loading',
         });

         this.$http.getBgmBatchNo({
            ids: [row.bgmId],
         }).then(res => {
            console.log('批号数据返回:', res);
            loading.close(); // 关闭加载提示

            if (res.status == 200 && res.result && res.result.length > 0) {
               this.batchnoList = res.result;
               // 默认选中第一个批号
               this.selectedBatchnoIndex = 0;
               this.batchnoListVisible = true;
            } else {
               this.$message({
                  type: 'warning',
                  message: '未找到批号信息'
               });
            }
         }).catch(error => {
            loading.close(); // 关闭加载提示
            console.error('获取批号列表出错:', error);
            this.$message({
               type: 'error',
               message: '获取批号列表失败'
            });
         });
      },
      submitBatchnoSelection() {
         console.log('提交批号选择', this.selectedRowIndex, this.selectedBatchnoIndex);

         // 确保有选中的批号、有效的行索引和giftList中对应的行存在
         if (
            this.selectedRowIndex !== -1 &&
            this.batchnoList.length > 0 &&
            this.selectedBatchnoIndex >= 0 &&
            this.selectedBatchnoIndex < this.batchnoList.length &&
            this.sendDataInfo.giftList &&
            this.sendDataInfo.giftList[this.selectedRowIndex]
         ) {
            try {
               // 获取选中的批号
               const selectedBatchno = this.batchnoList[this.selectedBatchnoIndex].batchno;

               // 使用Vue的$set方法确保视图更新
               this.$set(
                  this.sendDataInfo.giftList[this.selectedRowIndex],
                  'batchno',
                  selectedBatchno
               );

               // 添加成功提示
               this.$message({
                  type: 'success',
                  message: `批号 ${selectedBatchno} 设置成功`
               });

               // 清空状态
               this.currentRowData = null;
            } catch (error) {
               console.error('设置批号时出错:', error);
               this.$message({
                  type: 'error',
                  message: '设置批号时出错'
               });
            }
         } else {
            console.error('批号选择条件不满足', {
               selectedRowIndex: this.selectedRowIndex,
               batchnoListLength: this.batchnoList.length,
               selectedBatchnoIndex: this.selectedBatchnoIndex,
               hasSpecialList: !!this.sendDataInfo.giftList,
               hasRow: this.sendDataInfo.giftList && !!this.sendDataInfo.giftList[this.selectedRowIndex]
            });
            this.$message({
               type: 'warning',
               message: '请先选择一个批号'
            });
         }
         this.batchnoListVisible = false;
      },

      handleBatchnoClick(row, column, event) {
         console.log(row, 'row clicked');
         // 直接通过行索引设置选中状态
         const index = this.batchnoList.findIndex(item => item.batchno === row.batchno);
         if (index !== -1) {
            this.selectedBatchnoIndex = index;
            console.log('设置选中批号索引:', index);
         }
      },

      onBatchnoDialogOpen() {
         // 弹窗打开时，确保默认选中第一个批号
         this.selectedBatchnoIndex = 0;
         console.log('批号弹窗打开，当前行索引:', this.selectedRowIndex, '批号列表长度:', this.batchnoList.length);
      },

      onBatchnoDialogClose() {
         // 弹窗关闭时，清空批号列表
         console.log('批号弹窗关闭');
      },
      // 添加优惠券
      addCouponDetails() {
         this.couponSearchForm.yhqName = "";
         this.searchCoupons();
         this.couponListVisible = true;

      },

      // 删除优惠券
      deleteCouponDetails() {
         if (this.sendDataInfo.couponList && this.sendDataInfo.couponList.length > 0) {
            this.sendDataInfo.couponList.splice(this.selectedCouponIndex, 1);
            this.selectedCouponIndex = 0;
         } else {
            return this.$message({
               message: "暂无可删除优惠券",
               type: "warning",
            });
         }
      },

      // 双击优惠券行
      openCouponDetailsBox(row, column, event) {
         this.editCouponDetailsIndex = row.index;
         this.couponList = JSON.parse(JSON.stringify(row));
      },

      // 格式化日期
      formatDate(timestamp) {
         if (!timestamp) return '未设置';
         return this.$moment(timestamp).format('YYYY-MM-DD');
      },
      formatDateTime(timestamp) {
         if (!timestamp) return '未设置';
         return this.$moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
      },
      // 查询优惠券列表
      searchCoupons() {
         this.couponCurrentPage = 1;
         this.getCouponList();
      },

      // 获取优惠券数据
      async getCouponList() {
         try {
            let params = {
               businessId: "",
               yhqName: this.couponSearchForm.yhqName,
               page: this.couponCurrentPage,
               rows: this.couponPageSize,
               start: '',
               end: '',
               ormId: 0,
               state: 2

            };

            // 这里替换为实际的API调用
            let responseData = await this.$http.getYhqListHistory(params);
            if (responseData.status == 200) {
               this.couponsList = responseData.result.list;
               this.couponTotal = responseData.result.total;
            } else {
               this.$message({
                  message: responseData.message || "获取优惠券列表失败",
                  type: "error",
               });
            }
         } catch (error) {
            console.error("获取优惠券列表出错:", error);
            this.$message({
               message: "获取优惠券列表出错",
               type: "error"
            });
         }
      },

      // 处理优惠券选择变化
      handleCouponSelectionChange(val) {
         this.selectedCoupons = val;
      },

      // 选择全部优惠券
      async selectAllCoupons() {
         try {
            this.$message({
               message: "正在获取所有优惠券数据，请稍候...",
               type: "info"
            });

            // 保存当前查询条件
            const params = {
               businessId: "",
               yhqName: this.couponSearchForm.yhqName,
               page: 1,
               rows: 1000, // 一次性获取大量数据
               start: '',
               end: '',
               ormId: 0
            };

            // 获取所有数据
            let responseData = await this.$http.getYhqList(params);

            if (responseData.status == 200) {
               // 显示选择的优惠券数量
               this.$message({
                  message: `已选择全部 ${responseData.result.total} 个优惠券`,
                  type: "success"
               });

               // 保存所有优惠券数据
               this.allCouponsList = responseData.result.list || [];

               // 设置选中状态
               if (this.$refs.couponsTable) {
                  // 先清空当前选中状态
                  this.$refs.couponsTable.clearSelection();

                  // 设置当前页面的优惠券为选中状态
                  this.couponsList.forEach(row => {
                     this.$refs.couponsTable.toggleRowSelection(row, true);
                  });
               }

               // 保存所有优惠券的ID
               this.selectedAllCoupons = true;
               this.allCouponsIds = this.allCouponsList.map(item => item.yhqId);
            } else {
               this.$message({
                  message: responseData.message || "获取全部优惠券失败",
                  type: "error"
               });
            }
         } catch (error) {
            console.error("获取全部优惠券出错:", error);
            this.$message({
               message: "获取全部优惠券出错",
               type: "error"
            });
         }
      },

      // 提交优惠券选择
      submitCouponSelection() {
         // 判断是否有选中的优惠券
         if ((!this.selectedCoupons || this.selectedCoupons.length === 0) &&
            (!this.selectedAllCoupons || !this.allCouponsIds || this.allCouponsIds.length === 0)) {
            this.$message({
               message: "请至少选择一个优惠券",
               type: "warning"
            });
            return;
         }

         // 根据是否选择全部，确定要处理的优惠券数据
         let processItems = [];
         let processCount = 0;

         if (this.selectedAllCoupons && this.allCouponsList && this.allCouponsList.length > 0) {
            // 处理全部选择的情况
            processItems = this.allCouponsList;
            processCount = processItems.length;
         } else {
            // 处理普通选择的情况
            processItems = this.selectedCoupons;
            processCount = processItems.length;
         }

         // 添加优惠券到列表
         let addedCount = 0;

         if (!this.sendDataInfo.couponList) {
            this.sendDataInfo.couponList = [];
         }

         processItems.forEach(item => {
            // 检查是否已存在相同的优惠券
            const exists = this.sendDataInfo.couponList.some(
               existingItem => existingItem.yhqId === item.yhqId
            );

            if (!exists) {
               // 添加到优惠券列表
               this.sendDataInfo.couponList.push({
                  yhqId: item.yhqId,
                  yhqName: item.yhqName,
                  yhqDesc: item.yhqDesc || '',
                  limitDay: item.limitDay || '',
                  remark: item.remark || '',
                  giftNum: item.giftNum || 1
               });
               addedCount++;
            }
         });

         this.$message({
            message: `已添加 ${addedCount} 个优惠券`,
            type: "success"
         });

         // 关闭对话框
         this.couponListVisible = false;

         // 重置选择状态
         this.selectedAllCoupons = false;
         this.allCouponsList = [];
         this.allCouponsIds = [];
      },

      // 处理优惠券分页大小变化
      handleCouponSizeChange(val) {
         this.couponPageSize = val;
         this.getCouponList();
      },

      // 处理优惠券当前页变化
      handleCouponCurrentChange(val) {
         this.couponCurrentPage = val;
         this.getCouponList();
      },
      // -----------------通用名称列表-----------------
      searchCommonNames() {
         this.currentPage = 1;
         this.getDataCommonNames();
      },
      chooseAll() {

         this.pageSize = 3000
         this.getDataCommonNames();

      },
      async getDataCommonNames() {
         let params = {
            businessId: "",
            bgmName: this.searchForm.bgmName,
            manufacturer: this.searchForm.manufacturer,
            btId: this.searchForm.btId,
            page: this.currentPage,
            rows: this.pageSize,

            start: '',
            end: '',
            ormId: 0
         };
         let responseData;
         console.log(this.currentOperationType, 'this.currentOperationType')
         if (this.currentOperationType == 'gift') {
            responseData = await this.$http.deraBgmTypeGetOtherBgmListByType(params);
         } else {
            responseData = await this.$http.getBgmListByType(params);
         }
         if (responseData.status == 200) {
            this.commonNamesList = responseData.result.list;
            this.total = responseData.result.total;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      handleCommonNameSelectionChange(val) {
         this.selectedCommonNames = val.map(item => item.bgmId);
      },
      submitCommonNameSelection() {
         if (this.goodsSelectionMode === 'single') {
            // 单选模式：参与商品选择
            if (this.selectedGoodsIndexSingle === null || this.selectedGoodsIndexSingle === undefined) {
               this.$message({
                  message: "请选择一个商品",
                  type: "warning"
               });
               return;
            }

            // 获取选中的商品
            const selectedItem = this.commonNamesList[this.selectedGoodsIndexSingle];
            if (!selectedItem) {
               this.$message({
                  message: "选中的商品无效",
                  type: "warning"
               });
               return;
            }

            // 检查是否已经有商品（只允许一条）
            if (this.sendDataInfo.specialList.length > 0) {
               this.$message({
                  message: "参与商品列表只能添加一条数据，请先删除现有数据",
                  type: "warning"
               });
               return;
            }

            // 添加选中的商品到列表
            this.sendDataInfo.specialList.push({
               bgmId: selectedItem.bgmId,
               bgmName: selectedItem.bgmName,
               bgmCode: selectedItem.bgmCode,
               spec: selectedItem.spec,
               manufacturer: selectedItem.manufacturer,
               retailPrice: selectedItem.retailPrice,
               maxPsprice: selectedItem.maxPsprice,
               placeorigin: selectedItem.placeorigin,
               itemQtyRequired: "",
               itemAmountRequired: "",
               priceSet: 1
            });

            this.$message({
               message: "已添加商品到参与商品列表",
               type: "success"
            });

            // 重置选择状态
            this.selectedGoodsIndexSingle = null;
         } else {
            // 多选模式：原有的多选逻辑
            // 判断是否有选中的商品
            if ((!this.selectedCommonNames || this.selectedCommonNames.length === 0) &&
               (!this.selectedAllCommonNames || !this.allCommonNamesIds || this.allCommonNamesIds.length === 0)) {
               this.$message({
                  message: "请至少选择一个商品",
                  type: "warning"
               });
               return;
            }

            // 根据是否选择全部，确定要处理的商品数据
            let processItems = [];
            let processCount = 0;

            if (this.selectedAllCommonNames && this.allCommonNamesList && this.allCommonNamesList.length > 0) {
               // 处理全部选择的情况
               processItems = this.allCommonNamesList;
               processCount = processItems.length;
            } else {
               // 处理普通选择的情况
               processItems = this.commonNamesList.filter(item =>
                  this.selectedCommonNames.includes(item.bgmId)
               );
               processCount = processItems.length;
            }

            // 根据当前操作类型决定添加到哪个列表
            if (this.currentOperationType === 'gift') {
               // 添加赠品
               let addedCount = 0;
               processItems.forEach(item => {
                  // 检查是否已存在相同的赠品
                  const exists = this.sendDataInfo.giftList.some(
                     existingItem => existingItem.bgmId === item.bgmId
                  );

                  if (!exists) {
                     // 添加到赠品列表
                     this.sendDataInfo.giftList.push({
                        bgmId: item.bgmId,
                        bgmName: item.bgmName,
                        bgmCode: item.bgmCode,
                        bgmSpec: item.bgmSpec || "",
                        spec: item.spec,
                        manufacturer: item.manufacturer,
                        retailPrice: item.retailPrice,
                        maxPsprice: item.maxPsprice,
                        barcode: item.barcode || "",
                        placeorigin: item.placeorigin,
                        giftNum: 1,// 默认赠送数量为1
                        batchno: item.batchno || "",
                        goodType: item.goodType,
                     });
                     addedCount++;
                  }
               });

               this.$message({
                  message: `已添加 ${addedCount} 个商品到赠品列表`,
                  type: "success"
               });
            } else {
               // 添加参与商品
               let addedCount = 0;

               // 如果是参与商品模式，检查是否已达到限制
               if (!this.isExcludeGoodsMode && this.sendDataInfo.specialList.length >= 1) {
                  this.$message({
                     message: "参与商品列表只能添加一条数据",
                     type: "warning"
                  });
                  this.shopListVisible = false;
                  return;
               }

               processItems.forEach(item => {
                  // 如果是参与商品模式且已有数据，跳过添加
                  if (!this.isExcludeGoodsMode && this.sendDataInfo.specialList.length >= 1) {
                     return;
                  }

                  // 检查是否已存在相同的商品
                  const exists = this.sendDataInfo.specialList.some(
                     existingItem => existingItem.bgmId === item.bgmId
                  );

                  if (!exists) {
                     // 添加到商品列表
                     this.sendDataInfo.specialList.push({
                        bgmId: item.bgmId,
                        bgmName: item.bgmName,
                        bgmCode: item.bgmCode,
                        spec: item.spec,
                        manufacturer: item.manufacturer,
                        retailPrice: item.retailPrice,
                        maxPsprice: item.maxPsprice,
                        placeorigin: item.placeorigin,
                        itemQtyRequired: "",
                        itemAmountRequired: "",
                        priceSet: 1
                     });
                     addedCount++;

                     // 如果是参与商品模式，添加一条后就停止
                     if (!this.isExcludeGoodsMode) {
                        return;
                     }
                  }
               });

               this.$message({
                  message: `已添加 ${addedCount} 个商品到${this.isExcludeGoodsMode ? '不参与' : '参与'}商品列表`,
                  type: "success"
               });
            }

            // 重置选择状态
            this.selectedAllCommonNames = false;
            this.allCommonNamesList = [];
            this.allCommonNamesIds = [];
            this.selectedCommonNames = [];
         }

         // 关闭对话框
         this.shopListVisible = false;
      },
      handleSizeChange(val) {
         this.pageSize = val;
         this.getDataCommonNames();
      },
      handleCurrentChange(val) {
         this.currentPage = val;
         this.getDataCommonNames();
      },

      // 获取弹窗标题
      getDialogTitle() {
         if (this.currentOperationType === 'gift') {
            return '选择赠品商品';
         } else {
            return this.actionData.cate === 0 ? '添加通用商品明细' : '编辑通用商品明细';
         }
      },
      handleRowGiftModalClick(row) {
         console.log(row, 'rowGiftModal');
         if (this.goodsSelectionMode === 'single') {
            // 单选模式：设置单选框选中
            const index = this.commonNamesList.findIndex(item => item.bgmId === row.bgmId);
            this.selectedGoodsIndexSingle = index;
         } else {
            // 多选模式：切换复选框选中状态
            this.$refs.commonNamesTable.toggleRowSelection(row);
         }
      },
      handleRowCouponClick(row) {
         // 点击商品名称选中数据
         console.log(row, 'rowCoupon');
         this.$refs.couponsTable.toggleRowSelection(row);
      },
      async selectAllCommonNames() {
         // 如果是参与商品模式且已有数据，禁止选择全部
         if (!this.isExcludeGoodsMode && this.sendDataInfo.specialList.length >= 1) {
            this.$message({
               message: "参与商品列表只能添加一条数据",
               type: "warning"
            });
            return;
         }

         // 如果是参与商品模式，提示用户只能选择一个商品
         // if (!this.isExcludeGoodsMode) {
         //    this.$message({
         //       message: "参与商品列表只能添加一条数据，请手动选择一个商品",
         //       type: "warning"
         //    });
         //    return;
         // }

         try {

            // 显示加载提示
            const loading = this.$loading({
               lock: true,
               text: '正在加载数据...',
               spinner: 'el-icon-loading',
            });
            // 保存当前查询条件
            const params = {
               businessId: "",
               bgmName: this.searchForm.bgmName,
               manufacturer: this.searchForm.manufacturer,
               btId: this.searchForm.btId,
               page: 1,
               rows: 3000, // 一次性获取大量数据
               start: '',
               end: '',
               ormId: 0
            };

            // 获取所有数据
            let responseData = await this.$http.getBgmListByType(params);
            if (responseData.status == 200) {
               // 保存所有商品数据
               this.allCommonNamesList = responseData.result.list || [];



               // 保存所有商品的ID
               this.selectedAllCommonNames = true;
               this.allCommonNamesIds = this.allCommonNamesList.map(item => item.bgmId);
               this.shopListVisible = false
               this.submitCommonNameSelection()
            } else {
               this.$message({
                  message: responseData.message || "获取全部商品失败",
                  type: "error"
               });
            }
         } catch (error) {
            console.error("获取全部商品出错:", error);
            this.$message({
               message: "获取全部商品出错",
               type: "error"
            });
         } finally {
            loading.close();
         }
      },
      // -----------------商品分类列表-----------------
      searchCommonNamesF() {
         this.currentPageF = 1;
         this.getDataCommonNamesF();
      },
      // 选择全部商品分类
      async selectAllCommonNamesF() {
         try {

            // 显示加载提示
            const loading = this.$loading({
               lock: true,
               text: '正在加载数据...',
               spinner: 'el-icon-loading',
            });
            // 保存当前查询条件
            const params = {
               businessId: "",
               btName: this.searchForm.btName,
               page: 1,
               rows: 3000, // 一次性获取大量数据
               start: '',
               end: '',
               ormId: 0
            };

            // 获取所有数据
            let responseData = await this.$http.getTypeList(params);
            if (responseData.status == 200) {


               // 保存所有商品数据
               this.allCommonNamesListF = responseData.result.list || [];


               // 保存所有商品分类的ID
               this.selectedAllCommonNamesF = true;
               this.allCommonNamesIdsF = this.allCommonNamesListF.map(item => item.btId);
               this.shopListVisibleF = false
               this.submitCommonNameSelectionF()
            } else {
               this.$message({
                  message: responseData.message || "获取全部商品分类失败",
                  type: "error"
               });
            }
         } catch (error) {
            console.error("获取全部商品分类出错:", error);
            this.$message({
               message: "获取全部商品分类出错",
               type: "error"
            });
         } finally {
            loading.close();
         }
      },


      async getDataCommonNamesF() {
         let params = {
            btName: this.searchForm.btName,
            businessId: "",
            creater: 0,
            page: this.currentPageF,
            rows: this.pageSizeF,
            start: "",
            end: "",
            ormId: 0,
         };
         let responseData = await this.$http.getTypeList(params);
         if (responseData.status == 200) {
            this.commonNamesListF = responseData.result.list;
            this.totalF = responseData.result.total;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },


      handleSizeChangeF(val) {
         this.pageSizeF = val;
         this.getDataCommonNamesF();
      },
      handleCurrentChangeF(val) {
         this.currentPageF = val;
         this.getDataCommonNamesF();
      },
      handleRowGiftModalClickF(row) {
         console.log(row, 'rowGiftModalF');
         if (this.categorySelectionMode === 'single') {
            // 单选模式：设置单选框选中
            const index = this.commonNamesListF.findIndex(item => item.btId === row.btId);
            this.selectedCategoryIndexF = index;
         } else {
            // 多选模式：切换复选框选中状态
            this.$refs.commonNamesTableF.toggleRowSelection(row);
         }
      },
      handleCommonNameSelectionChangeF(val) {
         console.log('选中的商品分类:', val);
         // 检查val中的对象结构
         if (val && val.length > 0) {
            console.log('第一个选中项的结构:', JSON.stringify(val[0]));
         }
         // 保存选中的ID
         this.selectedCommonNamesF = val.map(item => item.btId);
         // 保存完整的选中对象，用于后续处理
         this.selectedCommonNamesObjects = val;
      },
      submitCommonNameSelectionF() {
         if (this.categorySelectionMode === 'single') {
            // 单选模式：商品分类选择
            if (this.selectedCategoryIndexF === null || this.selectedCategoryIndexF === undefined) {
               this.$message({
                  message: "请选择一个商品分类",
                  type: "warning"
               });
               return;
            }

            // 获取选中的商品分类
            const selectedItem = this.commonNamesListF[this.selectedCategoryIndexF];
            if (!selectedItem) {
               this.$message({
                  message: "选中的商品分类无效",
                  type: "warning"
               });
               return;
            }

            // 初始化商品分类列表（如果不存在）
            if (!this.sendDataInfo.conBgmTypeList) {
               this.sendDataInfo.conBgmTypeList = [];
            }

            // 检查是否已经有商品分类（只允许一条）
            if (this.sendDataInfo.conBgmTypeList.length > 0) {
               this.$message({
                  message: "参与商品分类列表只能添加一条数据，请先删除现有数据",
                  type: "warning"
               });
               return;
            }

            // 添加选中的商品分类到列表
            this.sendDataInfo.conBgmTypeList.push({
               btId: selectedItem.btId,
               btName: selectedItem.btName,
               btDesc: selectedItem.btDesc || '',
               num: '', // 数量要求，默认为空
               money: '', // 金额要求，默认为空
               priceSet: 1, // 价格设置类型，默认为价格不变
               remark: selectedItem.remark || ''
            });

            this.$message({
               message: "已添加商品分类",
               type: "success"
            });

            // 重置选择状态
            this.selectedCategoryIndexF = null;
         } else {
            // 多选模式：原有的多选逻辑（用于赠品等）
            // 判断是否有选中的商品
            if ((!this.selectedCommonNamesF || this.selectedCommonNamesF.length === 0) &&
               (!this.selectedAllCommonNamesF || !this.allCommonNamesIdsF || this.allCommonNamesIdsF.length === 0)) {
               this.$message({
                  message: "请至少选择一个商品分类",
                  type: "warning"
               });
               return;
            }

            // 根据是否选择全部，确定要处理的商品分类数据
            let processItems = [];

            if (this.selectedAllCommonNamesF && this.allCommonNamesListF && this.allCommonNamesListF.length > 0) {
               // 处理全部选择的情况
               processItems = this.allCommonNamesListF;
            } else {
               // 处理普通选择的情况
               // 优先使用保存的完整对象
               if (this.selectedCommonNamesObjects && this.selectedCommonNamesObjects.length > 0) {
                  processItems = this.selectedCommonNamesObjects;
               } else {
                  // 回退到通过ID过滤
                  processItems = this.commonNamesListF.filter(item =>
                     this.selectedCommonNamesF.includes(item.btId)
                  );
               }
            }

            // 初始化商品分类列表（如果不存在）
            if (!this.sendDataInfo.conBgmTypeList) {
               this.sendDataInfo.conBgmTypeList = [];
            }

            // 添加商品分类到列表
            let addedCount = 0;
            processItems.forEach(item => {
               // 检查是否已存在相同的商品分类
               const exists = this.sendDataInfo.conBgmTypeList.some(
                  existingItem => existingItem.btId === item.btId
               );

               if (!exists) {
                  // 添加到商品分类列表
                  this.sendDataInfo.conBgmTypeList.push({
                     btId: item.btId,
                     btName: item.btName,
                     btDesc: item.btDesc || '',
                     num: '', // 数量要求，默认为空
                     money: '', // 金额要求，默认为空
                     priceSet: 1, // 价格设置类型，默认为价格不变
                     remark: item.remark || ''
                  });
                  addedCount++;
               }
            });

            this.$message({
               message: `已添加 ${addedCount} 个商品分类`,
               type: "success"
            });

            // 重置选择状态
            this.selectedAllCommonNamesF = false;
            this.selectedCommonNamesObjects = [];
            this.allCommonNamesListF = [];
            this.allCommonNamesIdsF = [];
            this.selectedCommonNamesF = [];
         }

         // 关闭对话框
         this.shopListVisibleF = false;
      },
      handleFRowClick(row) {
         console.log(row, 'rowF');
         this.selectedDataIndexF = this.sendDataInfo.conBgmTypeList.findIndex(item => item.btId === row.btId)
      },
      openFDetailsBox(row, column, event) {
         this.editDateilsIndexF = row.index;
         this.sendDataInfo.conBgmTypeList = JSON.parse(JSON.stringify(row));
      },
      // 选择商品分类
      selectBgmType(row) {
         this.sendDataInfo.conBgmTypeList = JSON.parse(JSON.stringify(row));
      },

      // 促销周期和日期选择相关方法
      openPromotionDialog() {
         this.tempWeekDays = [...(this.sendDataInfo.mzWeekDays || [])];
         this.tempMonthDays = [...(this.sendDataInfo.mzMonthDays || [])];
         this.promotionDialogVisible = true;
      },
      confirmPromotionSelection() {
         this.sendDataInfo.mzWeekDays = [...this.tempWeekDays];
         this.sendDataInfo.mzMonthDays = [...this.tempMonthDays];
         this.promotionDialogVisible = false;
      },
      cancelPromotionSelection() {
         this.promotionDialogVisible = false;
      },
      selectAllWeekDays() {
         this.tempWeekDays = this.mzWeekDays.map(item => item.value);
      },
      clearAllWeekDays() {
         this.tempWeekDays = [];
      },
      selectAllMonthDays() {
         this.tempMonthDays = this.mzMonthDays.map(item => item.value);
      },
      clearAllMonthDays() {
         this.tempMonthDays = [];
      },

      // 方案选择相关方法
      openSchemeDialog() {
         console.log('openSchemeDialog 被调用', this.schemeDialogVisible);

         // 直接设置为 true
         this.schemeDialogVisible = true;
         this.selectedSchemeIndex = 0;

         // 添加调试信息
         console.log('设置后的状态:', this.schemeDialogVisible);

         // 检查弹窗元素是否存在
         this.$nextTick(() => {
            const dialogElement = document.querySelector('.promotion-dialog');
            console.log('弹窗元素:', dialogElement);

            const allDialogs = document.querySelectorAll('.el-dialog');
            console.log('所有弹窗元素:', allDialogs.length);

            this.getSchemeList();
         });
      },

      // 获取方案列表
      async getSchemeList() {
         try {
            // 这里需要根据实际的API接口来获取方案列表
            // 暂时使用模拟数据
            let responseData = await this.$http.getPlanListHistory(
               {
                  businessId: "",
                  creater: 0,
                  end: '',
                  ormId: 0,
                  page: 1,
                  planName: this.schemeSearchForm.planName,
                  planType: "",
                  reviewerCondition: "",
                  rows: 10,
                  start: '',
                  showType: this.actionData.limit
               }
            )
            if (responseData.status == 200) {
               this.schemeList = responseData.result.list
               this.schemeTotal = responseData.result.total
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               })
            }


         } catch (error) {
            console.error('获取方案列表失败:', error);
            this.$message.error('获取方案列表失败');
         }
      },

      // 搜索方案
      searchSchemes() {
         this.schemeCurrentPage = 1;
         this.getSchemeList();
      },

      // 重置搜索
      resetSchemeSearch() {
         this.schemeSearchForm = {
            planName: '',
            planType: ''
         };
         this.searchSchemes();
      },

      // 处理方案行点击
      handleSchemeRowClick(row, column, event) {
         const index = this.schemeList.findIndex(item => item.id === row.id);
         this.selectedSchemeIndex = index;
      },

      // 处理分页大小变化
      handleSchemeSizeChange(val) {
         this.schemePageSize = val;
         this.getSchemeList();
      },

      // 处理当前页变化
      handleSchemeCurrentChange(val) {
         this.schemeCurrentPage = val;
         this.getSchemeList();
      },

      // 应用选中的方案
      applySelectedScheme() {
         if (this.selectedSchemeIndex === null || this.selectedSchemeIndex < 0) {
            this.$message.warning('请选择一个方案');
            return;
         }

         const selectedScheme = this.schemeList[this.selectedSchemeIndex];
         if (!selectedScheme) {
            this.$message.warning('选中的方案不存在');
            return;
         }

         // 覆盖当前页面数据
         this.applySchemeData(selectedScheme);
         this.schemeDialogVisible = false;
         this.$message.success('方案应用成功');
      },

      // 应用方案数据到当前页面
      async applySchemeData(scheme) {
         console.log(scheme, 'scheme');
         // 获取商品详情内容
         let responseData = await this.$http.getPlanDetail({
            ids: [scheme.planId]
         })
         if (responseData.status == 200) {

            this.actionData.oldData = responseData.result
            this.checkDisabled = this.actionData?.checkDisabled ? true : false

            if (this.actionData.oldData) {
               for (let key in this.actionData.oldData) {
                  // 特殊处理周期类型
                  if (key === "roundWeek") {
                     const roundWeek = this.actionData.oldData[key].split(',');
                     this.sendDataInfo.mzWeekDays = roundWeek;
                  } else if (key === "roundDay") {
                     const roundDay = this.actionData.oldData[key].split(',');
                     this.sendDataInfo.mzMonthDays = roundDay;
                  } else if (key === "mzPileType") {
                     this.sendDataInfo.mzPileType = this.actionData.oldData[key].split(',');
                  } else if (key === "dayStartTime" || key === "dayEndTime") {
                     // 特殊处理每日时间字段，将秒数转换为时间字符串
                     const seconds = this.actionData.oldData[key];
                     if (seconds !== null && seconds !== undefined && seconds !== "") {
                        const hours = Math.floor(seconds / 3600);
                        const minutes = Math.floor((seconds % 3600) / 60);
                        const secs = seconds % 60;
                        const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
                        this.$set(this.sendDataInfo, key, timeString);
                     } else {
                        this.$set(this.sendDataInfo, key, "");
                     }
                  } else {
                     this.$set(this.sendDataInfo, key, this.actionData.oldData[key])
                  }
               }
               console.log(this.actionData.oldData.conBgmTypeList, 'this.actionData.oldData.conBgmTypeList');

               // 回显商品分类数据
               if (this.actionData.oldData.conBgmTypeList && this.actionData.oldData.conBgmTypeList.length > 0) {
                  this.sendDataInfo.conBgmTypeList = this.actionData.oldData.conBgmTypeList.map(item => ({
                     btId: item.btId || "",
                     btName: item.btName || "",
                     btDesc: item.btDesc || "",
                     num: item.num || "",
                     money: item.money || "",
                     priceSet: item.priceSet || 1,
                     remark: item.remark || "",
                  }));
               }
               console.log(this.actionData.oldData.banBgmList, 'this.actionData.oldData.banBgmList');

               // 回显不参与的商品列表
               if (this.actionData.oldData.banBgmList && this.actionData.oldData.banBgmList.length > 0) {
                  this.sendDataInfo.specialList = this.actionData.oldData.banBgmList.map(item => ({
                     bgmId: item.bgmId || "",
                     bgmName: item.bgmName || "",
                     bgmCode: item.bgmCode || "",
                     bgmSpec: item.bgmSpec || "",
                     spec: item.spec || "",
                     manufacturer: item.manufacturer || "",
                     barcode: item.barcode || "",
                     placeorigin: item.placeorigin || "",
                     retailPrice: item.retailPrice || "",
                     maxPsprice: item.maxPsprice || "",
                  }));
               }
               // 回显赠品数据
               if (this.actionData.oldData.conBgmList && this.actionData.oldData.conBgmList.length > 0) {
                  this.sendDataInfo.specialList = this.actionData.oldData.conBgmList.map(item => ({
                     bgmId: item.bgmId || "",
                     bgmName: item.bgmName || "",
                     bgmCode: item.bgmCode || "",
                     bgmSpec: item.bgmSpec || "",
                     spec: item.spec || "",
                     manufacturer: item.manufacturer || "",
                     barcode: item.barcode || "",
                     placeorigin: item.placeorigin || "",
                     retailPrice: item.retailPrice || "",
                     maxPsprice: item.maxPsprice || "",
                     itemQtyRequired: item.num || "",
                     itemAmountRequired: item.money || "",
                     priceSet: item.priceSet || 1,
                   

                  }));
                  console.log(this.sendDataInfo.specialList, 'this.sendDataInfo.specialList');

               }

               // 回显赠品赠送列表
               if (this.actionData.oldData.giftBgmList && this.actionData.oldData.giftBgmList.length > 0) {
                  this.sendDataInfo.giftList = this.actionData.oldData.giftBgmList.map(item => ({
                     bgmId: item.bgmId || "",
                     bgmName: item.bgmName || "",
                     bgmCode: item.bgmCode || "",
                     bgmSpec: item.bgmSpec || "",
                     spec: item.spec || "",
                     manufacturer: item.manufacturer || "",
                     barcode: item.barcode || "",
                     placeorigin: item.placeorigin || "",
                     retailPrice: item.retailPrice || "",
                     maxPsprice: item.maxPsprice || "",
                     price: item.price || "",
                     giftNum: item.giftNum || "",
                     batchno: item.batchno || "",
                     goodType: item.goodType || "",
                  }));
               }
console.log(this.sendDataInfo.giftList, 'this.sendDataInfo.giftList');
               // 回显优惠券列表
               if (this.actionData.oldData.giftYhqList && this.actionData.oldData.giftYhqList.length > 0) {
                  this.sendDataInfo.couponList = this.actionData.oldData.giftYhqList.map(item => ({
                     yhqId: item.yhqId || "",
                     yhqName: item.yhqName || "",
                     yhqDesc: item.yhqDesc || "",
                     limitDay: item.limitDay || "",
                     remark: item.remark || "",
                     giftNum: item.giftNum || "",
                  }));
               }

               // 回显会员卡类型和门店选择
               this.$nextTick(async () => {
                  // 回显会员卡类型选择
                  if (this.actionData.oldData.mcTypeList && this.actionData.oldData.mcTypeList.length > 0) {
                     await this.loadCardTypeData();
                     // 获取所有需要选中的卡类型ID
                     const selectedIds = this.actionData.oldData.mcTypeList.map(item => item.capId);
                     // 设置选中状态
                     this.selectedCardTypeIds = selectedIds;
                     // 设置选中的对象数组
                     this.selectedCardTypes = this.cardTypeList.filter(item => selectedIds.includes(item.capId));
                     console.log('已选中会员卡类型:', this.selectedCardTypes.length);
                  }

                  // 回显会员选择
                  // if (this.actionData.oldData.selectedMembers && this.actionData.oldData.selectedMembers.length > 0) {
                  //    const selectedMemberIds = this.actionData.oldData.selectedMembers
                  //    // 设置复选框选中的ID
                  //    this.selectedMemberIds = selectedMemberIds
                  //    // 设置选中的对象数组
                  //    this.selectedMembers = this.memberList.filter(item => selectedMemberIds.includes(item.memberId))
                  // }

                  // 回显门店选择
                  // 回显门店选择
                  if (this.actionData.oldData.storeList && this.actionData.oldData.storeList.length > 0) {
                     await this.loadStoreData();

                     setTimeout(() => {
                        const selectedStoreIds = this.actionData.oldData.storeList;
                        console.log(this.storeList, 'this.storeList');
                        // 确保 storeTable 存在
                        if (this.$refs.storeTable) {
                           this.storeList.forEach(item => {
                              const itemId = item.id || item.storeId;
                              // 检查是否存在匹配的门店ID
                              const isSelected = selectedStoreIds.some(store =>
                                 (store.id === itemId || store.storeId === itemId)
                              );
                              if (isSelected) {
                                 this.$refs.storeTable.toggleRowSelection(item, true);
                              }
                           });
                        }
                     }, 200);

                  }
               })
            }
         }

      },



   },
   mounted() {
      this.openBox()
      this.getTypeList()

   },


   beforeDestroy() {
   },
}
</script>
<style scoped>
:deep(.v_tabs_bottom) {
   background-color: #f0f1f4 !important;
}

.dialog-footer {
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   background: #fff;
   height: 46px;
   padding: 5px 10px;
   margin-top: 20px;
   border-top: 1px solid #eee;
}

#smManrange {
   width: 100%;
   display: flex;
   padding-left: 83px;
   margin-bottom: 10px;
}

::v-deep #smManrange .el-form-item__content {
   width: 100% !important;
}

::v-deep #smManrange .el-textarea__inner {
   width: 76% !important;
   margin-right: 20px;
   font-size: 12px;
}

.cmContent {
   padding-left: 10px;
   width: 90%;
}

.ellipsis-cell {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   display: block;
   width: 100%;
}

/* 表格滚动样式 */
::v-deep .el-table {
   overflow-y: auto;
}

::v-deep .el-table__body-wrapper {
   overflow-y: auto;
   height: 100%;
}

/* 新的促销设置布局样式 */
.main-layout {
   min-height: 100vh;
   position: relative;
}

.left-section {
   width: calc(100% - 450px);
   /* 减去右侧区域宽度(300px)和间距(40px) */
   display: flex;
   flex-direction: column;
   min-width: 0;
   padding-bottom: 60px;
   /* 为底部按钮留出空间 */
   padding-right: 20px;
   /* 为右侧区域留出间距 */
   box-sizing: border-box;
   /* 确保padding包含在宽度内 */
   max-width: calc(100% - 450px);
   /* 确保不超过最大宽度 */
   overflow-x: hidden;
   /* 防止水平溢出 */
}

.right-section {
   width: 30%;

   min-width: 450px;
   width: 300px;
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
   display: flex;
   flex-direction: column;
   overflow: hidden;
   /* 减去顶部和底部的空间 */
   position: fixed;
   /* 固定定位 */
   top: 13px;
   /* 距离顶部20px */
   right: 20px;
   /* 距离右侧20px */
   z-index: 1001;
   /* 确保在左侧内容之上 */
}

.right-content {
   padding: 15px;
   flex: 1;
   display: flex;
   flex-direction: column;
   overflow-y: auto;
   height: 100%;
   /* 确保内容区域占满高度 */
}

.right-content h3 {
   margin: 0 0 15px 0;
   font-size: 16px;
   font-weight: 600;
   color: #303133;
   border-bottom: 2px solid #409eff;
   padding-bottom: 10px;
}

.right-content p {
   margin: 0;
   color: #606266;
   font-size: 14px;
   line-height: 1.5;
}

.right-content::-webkit-scrollbar {
   width: 4px;
}

.right-content::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 2px;
}

.right-content::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 2px;
}

.right-content::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}

.form-section {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   padding: 20px;
   margin-bottom: 20px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
   flex-shrink: 0;
   /* 防止被压缩 */
}

.promotion-container {
   display: flex;
   flex: 1;
   min-height: 0;
   overflow: visible;
   margin-bottom: 20px;
}

.promotion-section {
   margin-top: 10px;
   width: 100%;
   /* background: #fff; */
   /* border: 1px solid #e4e7ed; */
   /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); */
   display: flex;
   flex-direction: column;
   overflow: hidden;
}

.condition-section {
   width: 100%;
}

.section-header {
   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
   color: white;
   padding: 20px 25px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   position: relative;
   flex-shrink: 0;
}

.header-left h3 {
   margin: 0 0 5px 0;
   font-size: 18px;
   font-weight: 600;
   display: flex;
   align-items: center;
}

.section-desc {
   margin: 0;
   font-size: 13px;
   opacity: 0.9;
   font-weight: 400;
}

.header-actions-box {
   display: flex;
   gap: 10px;
   box-sizing: border-box;
}

.section-content {
   display: flex;
   flex-direction: column;
   flex: 1;
   /* 占据剩余空间 */
   height: 100%;
   /* 确保占满父容器高度 */
   overflow: hidden;
   /* 防止出现双滚动条 */
   min-height: 0;
}

/* 类型选择器样式 */
.type-selector {
   background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
   padding: 20px;
   border: 1px solid #e4e7ed;
   flex-shrink: 0;
}

/* 商品列表容器样式 */
.goods-list-container {
   background: #fff;
   border: 1px solid #e4e7ed;
   /* overflow: hidden; */
   flex: 1;
   display: flex;
   flex-direction: column;
   overflow: hidden;
   min-height: 0;
}

.list-header {
   background: #f5f7fa;
   padding: 15px 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border-bottom: 1px solid #e4e7ed;
   flex-shrink: 0;
}

.list-title {
   font-size: 14px;
   font-weight: 600;
   color: #303133;
}

.list-count {
   font-size: 12px;
   color: #606266;
   padding: 4px 8px;
   background: rgba(64, 158, 255, 0.1);
   border-radius: 4px;
   border: 1px solid rgba(64, 158, 255, 0.2);
}

.goods-table-wrapper {
   padding: 0;
   flex: 1;
   overflow: visible;
   /* min-height: 400px; */
}

/* 阶梯阶梯设置样式 */
.step-scheme-container {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   flex: 1;
   display: flex;
   flex-direction: column;
   height: 100%;
   /* 确保占满父容器高度 */
   min-height: 400px;
   /* 设置最小高度 */
}

.scheme-layout {
   display: flex;
   flex: 1;
   /* 占据剩余空间 */
   height: 100%;
   /* 确保占满父容器高度 */
   overflow: hidden;
   /* 防止出现双滚动条 */
}

.scheme-list {
   width: 22%;
   border-right: 1px solid #e4e7ed;
   display: flex;
   flex-direction: column;
   background: #fafafa;
   height: 100%;
   /* 确保占满父容器高度 */
}

.scheme-list .list-header {
   flex-shrink: 0;
   /* 防止头部被压缩 */
   background: #f5f7fa;
   padding: 15px 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border-bottom: 1px solid #e4e7ed;
}

/* 右侧商品管理样式 */
.scheme-goods {
   width: 78%;
   display: flex;
   flex-direction: column;
   background: #fff;
   height: 100%;
   /* 确保占满父容器高度 */
}

.scheme-items {
   flex: 1;
   /* 占据剩余空间 */
   overflow-y: auto;
   /* 垂直滚动 */
   overflow-x: hidden;
   /* 隐藏水平滚动 */
   padding: 15px;
   height: 100%;
   /* 铺满100%高度 */
}

/* 自定义滚动条样式 */
.scheme-items::-webkit-scrollbar {
   width: 6px;
}

.scheme-items::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 3px;
}

.scheme-items::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 3px;
}

.scheme-items::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}

.scheme-item {
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 15px;
   margin-bottom: 10px;
   border: 2px solid #e4e7ed;
   border-radius: 8px;
   cursor: pointer;
   transition: all 0.3s ease;
   background: #fff;
   position: relative;
   /* overflow: hidden; */
}

.scheme-item:hover {
   border-color: #409eff;
   box-shadow: 0 4px 16px rgba(64, 158, 255, 0.15);
   transform: translateY(-2px);
}

.scheme-item.active {
   border-color: #409eff;
   background: linear-gradient(135deg, #ecf5ff 0%, #f0f9ff 100%);
   box-shadow: 0 6px 20px rgba(64, 158, 255, 0.2);
   transform: translateY(-2px);
}

.scheme-info {
   flex: 1;
   display: flex;
   flex-direction: column;
   gap: 5px;
}

.scheme-title {
   font-weight: 600;
   color: #303133;
   font-size: 14px;
}

.scheme-desc {
   color: #909399;
   font-size: 12px;
   white-space: nowrap;
   /* overflow: hidden; */
   text-overflow: ellipsis;
}

.scheme-goods-count {
   color: #409eff;
   font-size: 11px;
   font-weight: 500;
   padding: 2px 6px;
   background: rgba(64, 158, 255, 0.1);
   border-radius: 3px;
   display: inline-block;
   width: fit-content;
}

.scheme-actions {
   opacity: 0;
   transition: opacity 0.3s ease;
}

.scheme-item:hover .scheme-actions,
.scheme-item.active .scheme-actions {
   opacity: 1;
}

.quick-actions {
   display: flex;
   flex-direction: column;
   gap: 10px;
}

.quick-actions .el-button {
   width: 100%;
   justify-content: center;
}

/* 右侧区域新样式 */
.card-type-section,
.store-section {
   margin-bottom: 16px;
   background: #fff;
   border: 1px solid #e8eaed;
   border-radius: 6px;
   overflow: hidden;
   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.card-type-section .section-header,
.store-section .section-header {
   background: #f8f9fa;
   border-bottom: 1px solid #e8eaed;
   padding: 12px 16px;
   display: flex;
   justify-content: space-between;
   align-items: center;
}

.header-content {
   display: flex;
   align-items: center;
   gap: 8px;
   font-size: 14px;
   font-weight: 500;
   color: #2c3e50;
}

.header-content i {
   font-size: 16px;
   color: #5a6c7d;
}

.selection-count {
   background: #e3f2fd;
   color: #1976d2;
   padding: 4px 8px;
   border-radius: 12px;
   font-size: 12px;
   font-weight: 500;
   min-width: 40px;
   text-align: center;
}

.table-container {
   padding: 0;
   background: #fff;
}

/* 卡片类型项目样式 */
.card-code-text {
   font-size: 12px;
   color: #5a6c7d;
   font-weight: 500;
   background: #f5f6fa;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

.card-name-text {
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.mzDiscount-text {
   font-size: 12px;
   color: #e74c3c;
   font-weight: 500;
   background: #fdf2f2;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

.no-mzDiscount {
   font-size: 12px;
   color: #95a5a6;
   font-style: italic;
}

/* 门店项目样式 */
.store-name-text {
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.store-type-text {
   font-size: 12px;
   color: #5a6c7d;
   background: #f0f2f5;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

.store-phone-text {
   font-size: 12px;
   color: #3498db;
   font-weight: 500;
}

.store-address-text {
   font-size: 12px;
   color: #7f8c8d;
   line-height: 1.3;
   max-width: 140px;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   display: block;
}

.store-area-text {
   font-size: 12px;
   color: #27ae60;
   background: #f0f9f4;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

/* 表格样式优化 */
::v-deep .el-table--mini {
   font-size: 12px;
   border: none;
}

::v-deep .el-table--mini .el-table__header th {
   background-color: #fafbfc;
   color: #5a6c7d;
   font-weight: 500;
   border-bottom: 1px solid #e8eaed;
   padding: 10px 0;
}

::v-deep .el-table--mini .el-table__body td {
   padding: 8px 0;
   border-bottom: 1px solid #f5f6fa;
}

::v-deep .el-table--mini .el-table__body tr:hover > td {
   background-color: #f8f9fa;
}

::v-deep .el-table--mini .el-table__body tr:last-child > td {
   border-bottom: none;
}

/* 优雅表格样式 */
.elegant-table {
   border: none;
}

.elegant-table .el-table__header-wrapper {
   border-bottom: 1px solid #e8eaed;
}

.elegant-table .el-table__body-wrapper {
   background: #fff;
}

:deep(.el-table thead) {
   height: 40px !important;
}

/* 会员卡类型选择区域样式 */
.card-type-selection {
   border: 1px solid #e4e7ed;
   border-radius: 6px;
   background: #fff;
   overflow: hidden;
}

/* 会员选择区域样式 */
.member-selection {
   border: 1px solid #e4e7ed;
   border-radius: 6px;
   background: #fff;
   overflow: hidden;
}

.member-table {
   background: #fff;
}

.member-list {
   max-height: 200px;
   overflow-y: auto;
}

.member-item {
   display: flex;
   align-items: center;
   padding: 12px 16px;
   border-bottom: 1px solid #f5f6fa;
   transition: all 0.2s ease;
}

.member-item:hover {
   background: #f8f9fa;
}

.member-item:last-child {
   border-bottom: none;
}

.item-card {
   width: 120px;
   text-align: center;
   font-size: 12px;
   font-weight: 500;
   margin: 0 8px;
}

.item-type {
   width: 50px;
   text-align: center;
   font-size: 12px;
   margin: 0 8px;
}

.item-phone {
   width: 120px;
   text-align: center;
   font-size: 12px;
   color: #3498db;
   font-weight: 500;
}

.header-card {
   width: 120px;
   text-align: center;
}

.header-type {
   width: 100px;
   text-align: center;
}

.header-phone {
   width: 120px;
   text-align: center;
}

.selection-header {
   background: #f8f9fa;
   padding: 12px 16px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border-bottom: 1px solid #e8eaed;
}

.selection-title {
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.card-type-table {
   background: #fff;
}

.table-header {
   display: flex;
   align-items: center;
   background: #fafbfc;
   border-bottom: 1px solid #e8eaed;
   padding: 12px 16px;
   font-weight: 500;
   color: #5a6c7d;
   font-size: 13px;
}

.header-checkbox {
   display: flex;
   align-items: center;
}

.header-text {
   margin-left: 8px;
}

.header-code {
   width: 120px;
   text-align: center;
}

.header-name {
   flex: 1;
   text-align: center;
}

.header-mzDiscount {
   width: 100px;
   text-align: center;
}

.card-type-list {
   max-height: 200px;
   overflow-y: auto;
}

.card-type-list::-webkit-scrollbar {
   width: 4px;
}

.card-type-list::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 2px;
}

.card-type-list::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 2px;
}

.card-type-list::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}

.card-type-item {
   display: flex;
   align-items: center;
   padding: 12px 16px;
   border-bottom: 1px solid #f5f6fa;
   transition: all 0.2s ease;
}

.card-type-item:hover {
   background: #f8f9fa;
}

.card-type-item:last-child {
   border-bottom: none;
}

.item-checkbox {
   display: flex;
   align-items: center;
}

.item-code {
   width: 120px;
   text-align: center;
   font-size: 12px;

   font-weight: 500;

   margin: 0 8px;
}

.item-name {
   flex: 1;
   text-align: center;
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.item-mzDiscount {
   width: 100px;
   text-align: center;
}

/* 
.card-mzDiscount {
   font-size: 12px;
   color: #e74c3c;
   font-weight: 500;
   background: #fdf2f2;
   padding: 4px 8px;
   border-radius: 3px;
} */

.card-no-mzDiscount {
   font-size: 12px;
   color: #95a5a6;
   font-style: italic;
}

/* 复选框样式优化 */
::v-deep .el-checkbox {
   width: 100%;
   margin-right: 0;
}

::v-deep .el-checkbox__label {
   width: 100%;
   padding-left: 8px;
}

.promotion-condition-section {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   padding: 20px 20px 0 20px;
   margin-bottom: 20px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
   flex-shrink: 0;
}

.condition-title {
   font-size: 16px;
   font-weight: 600;
   color: #303133;
   margin-bottom: 20px;
   border-bottom: 1px solid #ebeef5;
   padding-bottom: 10px;
}

.disabled-container {
   position: relative;
   opacity: 0.7;
   pointer-events: none;
}

.disabled-container::after {
   content: "";
   position: absolute;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   background: rgba(255, 255, 255, 0.4);
   z-index: 10;
}

.disabled-notice {
   display: flex;
   align-items: center;
}

.disabled-notice .el-tag {
   margin-right: 10px;
}

/* 简约版头部样式 */
.section-header-simple {
   background: #f5f7fa;
   color: #333;
   padding: 15px 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   position: relative;
   flex-shrink: 0;
   border-bottom: 1px solid #e4e7ed;
}

.header-left-simple h3 {
   margin: 0 0 5px 0;
   font-size: 16px;
   font-weight: 600;
   color: #303133;
}

.section-desc-simple {
   margin: 0;
   font-size: 12px;
   color: #606266;
   font-weight: 400;
}

.header-actions-simple {
   display: flex;
   gap: 10px;
}

/* 促销内容块 */
.promotion-content-section {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   padding: 20px;
   margin-bottom: 20px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
   flex-shrink: 0;
}

.promotion-content-section .el-form-item {
   margin-bottom: 15px;
}

.promotion-content-section .el-form-item label {
   font-weight: 600;
   margin-bottom: 5px;
}

.promotion-content-section .el-input {
   width: 100%;
}

.promotion-content-section .el-select {
   width: 100%;
}

.promotion-content-section .el-radio-group {
   display: flex;
}

.promotion-content-section .el-radio-button {
   width: 100%;
}

.promotion-content-section .el-checkbox-group {
   display: flex;
   gap: 10px;
}

.promotion-content-section .el-checkbox-button {
   width: 100%;
}

/* 赠品商品表格样式 */
.gift-goods-section {
   /* background: #fff; */
   /* border: 1px solid #e4e7ed; */
   /* border-radius: 8px; */
   /* padding: 20px; */
   margin-top: 20px;
   /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06); */
}

.gift-goods-section .goods-table-wrapper {
   border: 1px solid #ebeef5;
   border-radius: 4px;
   overflow: hidden;
}

#mzMonthDays {
   display: flex;
}

:deep(#mzMonthDays .el-form-item__content) {
   width: 80% !important;
}

.section-title {
   padding: 16px 20px;
   background: #f5f7fa;
   border-bottom: 1px solid #e4e7ed;
}

.title-text {
   font-size: 16px;
   font-weight: bold;
   color: #303133;
   position: relative;
   padding-left: 12px;
   display: flex;
   align-items: center;
}

.title-text::before {
   content: "";
   position: absolute;
   left: 0;
   top: 50%;
   transform: translateY(-50%);
   width: 4px;
   height: 16px;
   background: #409eff;
   border-radius: 2px;
}

/* 现代化表单样式 */
.promotion-form {
   background: #fff;
   border-radius: 12px;
   padding: 24px;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
   margin-bottom: 20px;
}

/* 表单分组样式 - 与cxAdjustmentActionII.vue保持一致 */
.form-group {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   margin-bottom: 10px;
   overflow: hidden;
}

.group-title {
   background: #f8f9fa;
   padding: 12px 20px;
   font-size: 14px;
   font-weight: 600;
   color: #495057;
   border-bottom: 1px solid #e4e7ed;
   margin: 0;
   display: flex;
   justify-content: space-between;
}

.form-row {
   display: flex;
   gap: 20px;
   padding: 20px;
   align-items: flex-start;
}

.form-row:not(:last-child) {
   border-bottom: 1px solid #f5f5f5;
}

.form-item-half {
   flex: 1;
   margin-bottom: 0 !important;
}

.form-item-full {
   width: 100%;
   margin-bottom: 0 !important;
}

/* 表单项标签样式 */
::v-deep .promotion-form .el-form-item__label {
   font-weight: 500;
   color: #606266;
   padding-right: 12px;
}

/* 输入框样式统一 */
::v-deep .promotion-form .el-input__inner,
::v-deep .promotion-form .el-textarea__inner,
::v-deep .promotion-form .el-select .el-input__inner,
::v-deep .promotion-form .el-date-editor .el-input__inner {
   border-radius: 6px;
   border: 1px solid #dcdfe6;
   transition: all 0.3s ease;
}

::v-deep .promotion-form .el-input__inner:focus,
::v-deep .promotion-form .el-textarea__inner:focus,
::v-deep .promotion-form .el-select .el-input__inner:focus,
::v-deep .promotion-form .el-date-editor .el-input__inner:focus {
   border-color: #409eff;
   box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 促销周期和日期选择弹窗样式 - 与cxAdjustmentActionII.vue保持一致 */
.promotion-selection-container {
   padding: 20px;
}

.selection-section {
   margin-bottom: 30px;
}

.selection-section:last-child {
   margin-bottom: 0;
}

.section-header {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 15px;
   padding: 12px 16px;
   background: #f8f9fa;
   border-radius: 6px;
   border: 1px solid #e9ecef;
}

.section-header h4 {
   margin: 0;
   font-size: 16px;
   font-weight: 600;
   color: #495057;
}

.selection-actions {
   display: flex;
   gap: 8px;
}

.checkbox-group {
   display: flex;
   flex-wrap: wrap;
   gap: 8px;
}

.checkbox-group .el-checkbox-group {
   display: flex;
   flex-wrap: wrap;
   gap: 8px;
   width: 100%;
}

.checkbox-group .el-checkbox-button {
   margin-right: 0;
   margin-bottom: 8px;
}

/* 美化复选框按钮 */
::v-deep .el-checkbox-button__inner {
   border-radius: 6px;
   padding: 8px 16px;
   font-size: 14px;
   transition: all 0.3s ease;
}

::v-deep .el-checkbox-button.is-checked .el-checkbox-button__inner {
   background-color: #409eff;
   border-color: #409eff;
   color: #fff;
   box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
}

::v-deep .el-checkbox-button:not(.is-checked) .el-checkbox-button__inner:hover {
   background-color: #ecf5ff;
   border-color: #b3d8ff;
   color: #409eff;
}

/* 会员卡类型选择样式 */
.card-type-selection {
   border: 1px solid #e4e7ed;
   border-radius: 6px;
   background: #fff;
   overflow: hidden;
}

.selection-header {
   background: #f8f9fa;
   padding: 10px 15px;
   border-bottom: 1px solid #e8eaed;
}

.selection-title {
   font-size: 13px;
   color: #606266;
   font-weight: 500;
}

.table-header {
   display: flex;
   background: #f5f7fa;
   border-bottom: 1px solid #e8eaed;
   font-weight: 600;
   font-size: 12px;
   color: #909399;
}

.header-checkbox {
   width: 50px;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 8px;
   border-right: 1px solid #e8eaed;
}

.header-name {
   flex: 1;
   padding: 8px 12px;
   border-right: 1px solid #e8eaed;
}

.header-mzDiscount {
   width: 80px;
   padding: 8px 12px;
   text-align: center;
}

.card-type-item {
   display: flex;
   align-items: center;
   cursor: pointer;
   transition: background-color 0.2s;
   border-bottom: 1px solid #f0f0f0;
}

.card-type-item:hover {
   background-color: #f5f7fa;
}

.item-checkbox {
   width: 50px;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 8px;
   border-right: 1px solid #f0f0f0;
}

.item-name {
   flex: 1;
   padding: 8px 12px;
   border-right: 1px solid #f0f0f0;
   font-size: 13px;
   color: #303133;
}

.item-mzDiscount {
   width: 80px;
   padding: 8px 12px;
   text-align: center;
}

/* 
.card-mzDiscount {
   background: #fff2f0;
   color: #e74c3c;
   padding: 2px 6px;
   border-radius: 3px;
   font-size: 11px;
   font-weight: 500;
} */

.card-no-mzDiscount {
   color: #909399;
   font-size: 11px;
}

/* 响应式布局 */
@media (max-width: 1200px) {
   .form-row {
      flex-direction: column;
      gap: 16px;
   }

   .form-item-half {
      width: 100%;
   }
}
</style>